var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1227,
    viewBox: "0 0 1920 1227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_909",
    "data-name": "Rect\\xE1ngulo 909",
    width: 1920,
    height: 1227,
    transform: "translate(0 86)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_32",
    "data-name": "Elipse 32",
    cx: 258.516,
    cy: 258.516,
    r: 258.516,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_318",
    "data-name": "Trazado 318",
    d: "M188.482,421.384l386.814-.928V277.338l-386.814.928Z",
    transform: "translate(-188.482 -277.338)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_6",
    "data-name": "Enmascarar grupo 6",
    transform: "translate(0 -86)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carmuuuu_sticker",
    "data-name": "carmuuuu sticker",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 1890.281, -753.441)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_31",
    "data-name": "Elipse 31",
    cx: 258.516,
    cy: 258.516,
    r: 258.516,
    transform: "translate(-1143.504 1474.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_244",
    "data-name": "Grupo 244",
    transform: "translate(-1143.504 1474.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_243",
    "data-name": "Grupo 243",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_242",
    "data-name": "Grupo 242",
    transform: "translate(-8.071 -15.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_207",
    "data-name": "Grupo 207",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_194",
    "data-name": "Grupo 194",
    transform: "translate(0 90.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_191",
    "data-name": "Grupo 191",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_333",
    "data-name": "Rect\\xE1ngulo 333",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_334",
    "data-name": "Rect\\xE1ngulo 334",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_335",
    "data-name": "Rect\\xE1ngulo 335",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_336",
    "data-name": "Rect\\xE1ngulo 336",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_337",
    "data-name": "Rect\\xE1ngulo 337",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_338",
    "data-name": "Rect\\xE1ngulo 338",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_339",
    "data-name": "Rect\\xE1ngulo 339",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_340",
    "data-name": "Rect\\xE1ngulo 340",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_192",
    "data-name": "Grupo 192",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_341",
    "data-name": "Rect\\xE1ngulo 341",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_342",
    "data-name": "Rect\\xE1ngulo 342",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_343",
    "data-name": "Rect\\xE1ngulo 343",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_344",
    "data-name": "Rect\\xE1ngulo 344",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_345",
    "data-name": "Rect\\xE1ngulo 345",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_346",
    "data-name": "Rect\\xE1ngulo 346",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_347",
    "data-name": "Rect\\xE1ngulo 347",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_348",
    "data-name": "Rect\\xE1ngulo 348",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_193",
    "data-name": "Grupo 193",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_349",
    "data-name": "Rect\\xE1ngulo 349",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_350",
    "data-name": "Rect\\xE1ngulo 350",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_351",
    "data-name": "Rect\\xE1ngulo 351",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_352",
    "data-name": "Rect\\xE1ngulo 352",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_353",
    "data-name": "Rect\\xE1ngulo 353",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_354",
    "data-name": "Rect\\xE1ngulo 354",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_355",
    "data-name": "Rect\\xE1ngulo 355",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_356",
    "data-name": "Rect\\xE1ngulo 356",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_198",
    "data-name": "Grupo 198",
    transform: "translate(271.668 90.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_195",
    "data-name": "Grupo 195",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_357",
    "data-name": "Rect\\xE1ngulo 357",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_358",
    "data-name": "Rect\\xE1ngulo 358",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_359",
    "data-name": "Rect\\xE1ngulo 359",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_360",
    "data-name": "Rect\\xE1ngulo 360",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_361",
    "data-name": "Rect\\xE1ngulo 361",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_362",
    "data-name": "Rect\\xE1ngulo 362",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_363",
    "data-name": "Rect\\xE1ngulo 363",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_364",
    "data-name": "Rect\\xE1ngulo 364",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_196",
    "data-name": "Grupo 196",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_365",
    "data-name": "Rect\\xE1ngulo 365",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_366",
    "data-name": "Rect\\xE1ngulo 366",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_367",
    "data-name": "Rect\\xE1ngulo 367",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_368",
    "data-name": "Rect\\xE1ngulo 368",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_369",
    "data-name": "Rect\\xE1ngulo 369",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_370",
    "data-name": "Rect\\xE1ngulo 370",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_371",
    "data-name": "Rect\\xE1ngulo 371",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_372",
    "data-name": "Rect\\xE1ngulo 372",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_197",
    "data-name": "Grupo 197",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_373",
    "data-name": "Rect\\xE1ngulo 373",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_374",
    "data-name": "Rect\\xE1ngulo 374",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_375",
    "data-name": "Rect\\xE1ngulo 375",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_376",
    "data-name": "Rect\\xE1ngulo 376",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_377",
    "data-name": "Rect\\xE1ngulo 377",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_378",
    "data-name": "Rect\\xE1ngulo 378",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_379",
    "data-name": "Rect\\xE1ngulo 379",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_380",
    "data-name": "Rect\\xE1ngulo 380",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_202",
    "data-name": "Grupo 202",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_199",
    "data-name": "Grupo 199",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_381",
    "data-name": "Rect\\xE1ngulo 381",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_382",
    "data-name": "Rect\\xE1ngulo 382",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_383",
    "data-name": "Rect\\xE1ngulo 383",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_384",
    "data-name": "Rect\\xE1ngulo 384",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_385",
    "data-name": "Rect\\xE1ngulo 385",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_386",
    "data-name": "Rect\\xE1ngulo 386",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_387",
    "data-name": "Rect\\xE1ngulo 387",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_388",
    "data-name": "Rect\\xE1ngulo 388",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_200",
    "data-name": "Grupo 200",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_389",
    "data-name": "Rect\\xE1ngulo 389",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_390",
    "data-name": "Rect\\xE1ngulo 390",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_391",
    "data-name": "Rect\\xE1ngulo 391",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_392",
    "data-name": "Rect\\xE1ngulo 392",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_393",
    "data-name": "Rect\\xE1ngulo 393",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_394",
    "data-name": "Rect\\xE1ngulo 394",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_395",
    "data-name": "Rect\\xE1ngulo 395",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_396",
    "data-name": "Rect\\xE1ngulo 396",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_201",
    "data-name": "Grupo 201"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_397",
    "data-name": "Rect\\xE1ngulo 397",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_398",
    "data-name": "Rect\\xE1ngulo 398",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_399",
    "data-name": "Rect\\xE1ngulo 399",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_400",
    "data-name": "Rect\\xE1ngulo 400",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_401",
    "data-name": "Rect\\xE1ngulo 401",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_402",
    "data-name": "Rect\\xE1ngulo 402",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_403",
    "data-name": "Rect\\xE1ngulo 403",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_404",
    "data-name": "Rect\\xE1ngulo 404",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_206",
    "data-name": "Grupo 206",
    transform: "translate(271.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_203",
    "data-name": "Grupo 203",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_405",
    "data-name": "Rect\\xE1ngulo 405",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_406",
    "data-name": "Rect\\xE1ngulo 406",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_407",
    "data-name": "Rect\\xE1ngulo 407",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_408",
    "data-name": "Rect\\xE1ngulo 408",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_409",
    "data-name": "Rect\\xE1ngulo 409",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_410",
    "data-name": "Rect\\xE1ngulo 410",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_411",
    "data-name": "Rect\\xE1ngulo 411",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_412",
    "data-name": "Rect\\xE1ngulo 412",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_204",
    "data-name": "Grupo 204",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_413",
    "data-name": "Rect\\xE1ngulo 413",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_414",
    "data-name": "Rect\\xE1ngulo 414",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_415",
    "data-name": "Rect\\xE1ngulo 415",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_416",
    "data-name": "Rect\\xE1ngulo 416",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_417",
    "data-name": "Rect\\xE1ngulo 417",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_418",
    "data-name": "Rect\\xE1ngulo 418",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_419",
    "data-name": "Rect\\xE1ngulo 419",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_420",
    "data-name": "Rect\\xE1ngulo 420",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_205",
    "data-name": "Grupo 205",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_421",
    "data-name": "Rect\\xE1ngulo 421",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_422",
    "data-name": "Rect\\xE1ngulo 422",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_423",
    "data-name": "Rect\\xE1ngulo 423",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_424",
    "data-name": "Rect\\xE1ngulo 424",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_425",
    "data-name": "Rect\\xE1ngulo 425",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_426",
    "data-name": "Rect\\xE1ngulo 426",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_427",
    "data-name": "Rect\\xE1ngulo 427",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_428",
    "data-name": "Rect\\xE1ngulo 428",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_224",
    "data-name": "Grupo 224",
    transform: "translate(0 181.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_211",
    "data-name": "Grupo 211",
    transform: "translate(0 90.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_208",
    "data-name": "Grupo 208",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_429",
    "data-name": "Rect\\xE1ngulo 429",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_430",
    "data-name": "Rect\\xE1ngulo 430",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_431",
    "data-name": "Rect\\xE1ngulo 431",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_432",
    "data-name": "Rect\\xE1ngulo 432",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_433",
    "data-name": "Rect\\xE1ngulo 433",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_434",
    "data-name": "Rect\\xE1ngulo 434",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_435",
    "data-name": "Rect\\xE1ngulo 435",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_436",
    "data-name": "Rect\\xE1ngulo 436",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_209",
    "data-name": "Grupo 209",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_437",
    "data-name": "Rect\\xE1ngulo 437",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_438",
    "data-name": "Rect\\xE1ngulo 438",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_439",
    "data-name": "Rect\\xE1ngulo 439",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_440",
    "data-name": "Rect\\xE1ngulo 440",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_441",
    "data-name": "Rect\\xE1ngulo 441",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_442",
    "data-name": "Rect\\xE1ngulo 442",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_443",
    "data-name": "Rect\\xE1ngulo 443",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_444",
    "data-name": "Rect\\xE1ngulo 444",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_210",
    "data-name": "Grupo 210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_445",
    "data-name": "Rect\\xE1ngulo 445",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_446",
    "data-name": "Rect\\xE1ngulo 446",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_447",
    "data-name": "Rect\\xE1ngulo 447",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_448",
    "data-name": "Rect\\xE1ngulo 448",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_449",
    "data-name": "Rect\\xE1ngulo 449",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_450",
    "data-name": "Rect\\xE1ngulo 450",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_451",
    "data-name": "Rect\\xE1ngulo 451",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_452",
    "data-name": "Rect\\xE1ngulo 452",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_215",
    "data-name": "Grupo 215",
    transform: "translate(271.668 90.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_212",
    "data-name": "Grupo 212",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_453",
    "data-name": "Rect\\xE1ngulo 453",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_454",
    "data-name": "Rect\\xE1ngulo 454",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_455",
    "data-name": "Rect\\xE1ngulo 455",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_456",
    "data-name": "Rect\\xE1ngulo 456",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_457",
    "data-name": "Rect\\xE1ngulo 457",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_458",
    "data-name": "Rect\\xE1ngulo 458",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_459",
    "data-name": "Rect\\xE1ngulo 459",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_460",
    "data-name": "Rect\\xE1ngulo 460",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_213",
    "data-name": "Grupo 213",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_461",
    "data-name": "Rect\\xE1ngulo 461",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_462",
    "data-name": "Rect\\xE1ngulo 462",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_463",
    "data-name": "Rect\\xE1ngulo 463",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_464",
    "data-name": "Rect\\xE1ngulo 464",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_465",
    "data-name": "Rect\\xE1ngulo 465",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_466",
    "data-name": "Rect\\xE1ngulo 466",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_467",
    "data-name": "Rect\\xE1ngulo 467",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_468",
    "data-name": "Rect\\xE1ngulo 468",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_214",
    "data-name": "Grupo 214",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_469",
    "data-name": "Rect\\xE1ngulo 469",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_470",
    "data-name": "Rect\\xE1ngulo 470",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_471",
    "data-name": "Rect\\xE1ngulo 471",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_472",
    "data-name": "Rect\\xE1ngulo 472",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_473",
    "data-name": "Rect\\xE1ngulo 473",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_474",
    "data-name": "Rect\\xE1ngulo 474",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_475",
    "data-name": "Rect\\xE1ngulo 475",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_476",
    "data-name": "Rect\\xE1ngulo 476",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_219",
    "data-name": "Grupo 219",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_216",
    "data-name": "Grupo 216",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_477",
    "data-name": "Rect\\xE1ngulo 477",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_478",
    "data-name": "Rect\\xE1ngulo 478",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_479",
    "data-name": "Rect\\xE1ngulo 479",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_480",
    "data-name": "Rect\\xE1ngulo 480",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_481",
    "data-name": "Rect\\xE1ngulo 481",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_482",
    "data-name": "Rect\\xE1ngulo 482",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_483",
    "data-name": "Rect\\xE1ngulo 483",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_484",
    "data-name": "Rect\\xE1ngulo 484",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_217",
    "data-name": "Grupo 217",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_485",
    "data-name": "Rect\\xE1ngulo 485",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_486",
    "data-name": "Rect\\xE1ngulo 486",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_487",
    "data-name": "Rect\\xE1ngulo 487",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_488",
    "data-name": "Rect\\xE1ngulo 488",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_489",
    "data-name": "Rect\\xE1ngulo 489",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_490",
    "data-name": "Rect\\xE1ngulo 490",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_491",
    "data-name": "Rect\\xE1ngulo 491",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_492",
    "data-name": "Rect\\xE1ngulo 492",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_218",
    "data-name": "Grupo 218",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_493",
    "data-name": "Rect\\xE1ngulo 493",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_494",
    "data-name": "Rect\\xE1ngulo 494",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_495",
    "data-name": "Rect\\xE1ngulo 495",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_496",
    "data-name": "Rect\\xE1ngulo 496",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_497",
    "data-name": "Rect\\xE1ngulo 497",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_498",
    "data-name": "Rect\\xE1ngulo 498",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_499",
    "data-name": "Rect\\xE1ngulo 499",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_500",
    "data-name": "Rect\\xE1ngulo 500",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_223",
    "data-name": "Grupo 223",
    transform: "translate(271.668 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_220",
    "data-name": "Grupo 220",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_501",
    "data-name": "Rect\\xE1ngulo 501",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_502",
    "data-name": "Rect\\xE1ngulo 502",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_503",
    "data-name": "Rect\\xE1ngulo 503",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_504",
    "data-name": "Rect\\xE1ngulo 504",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_505",
    "data-name": "Rect\\xE1ngulo 505",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_506",
    "data-name": "Rect\\xE1ngulo 506",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_507",
    "data-name": "Rect\\xE1ngulo 507",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_508",
    "data-name": "Rect\\xE1ngulo 508",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_221",
    "data-name": "Grupo 221",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_509",
    "data-name": "Rect\\xE1ngulo 509",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_510",
    "data-name": "Rect\\xE1ngulo 510",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_511",
    "data-name": "Rect\\xE1ngulo 511",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_512",
    "data-name": "Rect\\xE1ngulo 512",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_513",
    "data-name": "Rect\\xE1ngulo 513",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_514",
    "data-name": "Rect\\xE1ngulo 514",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_515",
    "data-name": "Rect\\xE1ngulo 515",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_516",
    "data-name": "Rect\\xE1ngulo 516",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_222",
    "data-name": "Grupo 222",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_517",
    "data-name": "Rect\\xE1ngulo 517",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_518",
    "data-name": "Rect\\xE1ngulo 518",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_519",
    "data-name": "Rect\\xE1ngulo 519",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_520",
    "data-name": "Rect\\xE1ngulo 520",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_521",
    "data-name": "Rect\\xE1ngulo 521",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_522",
    "data-name": "Rect\\xE1ngulo 522",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_523",
    "data-name": "Rect\\xE1ngulo 523",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_524",
    "data-name": "Rect\\xE1ngulo 524",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_241",
    "data-name": "Grupo 241",
    transform: "translate(0 362.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_228",
    "data-name": "Grupo 228",
    transform: "translate(0 90.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_225",
    "data-name": "Grupo 225",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_525",
    "data-name": "Rect\\xE1ngulo 525",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_526",
    "data-name": "Rect\\xE1ngulo 526",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_527",
    "data-name": "Rect\\xE1ngulo 527",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_528",
    "data-name": "Rect\\xE1ngulo 528",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_529",
    "data-name": "Rect\\xE1ngulo 529",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_530",
    "data-name": "Rect\\xE1ngulo 530",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_531",
    "data-name": "Rect\\xE1ngulo 531",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_532",
    "data-name": "Rect\\xE1ngulo 532",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_226",
    "data-name": "Grupo 226",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_533",
    "data-name": "Rect\\xE1ngulo 533",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_534",
    "data-name": "Rect\\xE1ngulo 534",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_535",
    "data-name": "Rect\\xE1ngulo 535",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_536",
    "data-name": "Rect\\xE1ngulo 536",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_537",
    "data-name": "Rect\\xE1ngulo 537",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_538",
    "data-name": "Rect\\xE1ngulo 538",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_539",
    "data-name": "Rect\\xE1ngulo 539",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_540",
    "data-name": "Rect\\xE1ngulo 540",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_227",
    "data-name": "Grupo 227",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_541",
    "data-name": "Rect\\xE1ngulo 541",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_542",
    "data-name": "Rect\\xE1ngulo 542",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_543",
    "data-name": "Rect\\xE1ngulo 543",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_544",
    "data-name": "Rect\\xE1ngulo 544",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_545",
    "data-name": "Rect\\xE1ngulo 545",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_546",
    "data-name": "Rect\\xE1ngulo 546",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_547",
    "data-name": "Rect\\xE1ngulo 547",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_548",
    "data-name": "Rect\\xE1ngulo 548",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_232",
    "data-name": "Grupo 232",
    transform: "translate(271.668 90.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_229",
    "data-name": "Grupo 229",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_549",
    "data-name": "Rect\\xE1ngulo 549",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_550",
    "data-name": "Rect\\xE1ngulo 550",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_551",
    "data-name": "Rect\\xE1ngulo 551",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_552",
    "data-name": "Rect\\xE1ngulo 552",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_553",
    "data-name": "Rect\\xE1ngulo 553",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_554",
    "data-name": "Rect\\xE1ngulo 554",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_555",
    "data-name": "Rect\\xE1ngulo 555",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_556",
    "data-name": "Rect\\xE1ngulo 556",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_230",
    "data-name": "Grupo 230",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_557",
    "data-name": "Rect\\xE1ngulo 557",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_558",
    "data-name": "Rect\\xE1ngulo 558",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_559",
    "data-name": "Rect\\xE1ngulo 559",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_560",
    "data-name": "Rect\\xE1ngulo 560",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_561",
    "data-name": "Rect\\xE1ngulo 561",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_562",
    "data-name": "Rect\\xE1ngulo 562",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_563",
    "data-name": "Rect\\xE1ngulo 563",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_564",
    "data-name": "Rect\\xE1ngulo 564",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_231",
    "data-name": "Grupo 231",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_565",
    "data-name": "Rect\\xE1ngulo 565",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_566",
    "data-name": "Rect\\xE1ngulo 566",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_567",
    "data-name": "Rect\\xE1ngulo 567",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_568",
    "data-name": "Rect\\xE1ngulo 568",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_569",
    "data-name": "Rect\\xE1ngulo 569",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_570",
    "data-name": "Rect\\xE1ngulo 570",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_571",
    "data-name": "Rect\\xE1ngulo 571",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_572",
    "data-name": "Rect\\xE1ngulo 572",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_236",
    "data-name": "Grupo 236",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_233",
    "data-name": "Grupo 233",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_573",
    "data-name": "Rect\\xE1ngulo 573",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_574",
    "data-name": "Rect\\xE1ngulo 574",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_575",
    "data-name": "Rect\\xE1ngulo 575",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_576",
    "data-name": "Rect\\xE1ngulo 576",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_577",
    "data-name": "Rect\\xE1ngulo 577",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_578",
    "data-name": "Rect\\xE1ngulo 578",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_579",
    "data-name": "Rect\\xE1ngulo 579",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_580",
    "data-name": "Rect\\xE1ngulo 580",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_234",
    "data-name": "Grupo 234",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_581",
    "data-name": "Rect\\xE1ngulo 581",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_582",
    "data-name": "Rect\\xE1ngulo 582",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_583",
    "data-name": "Rect\\xE1ngulo 583",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_584",
    "data-name": "Rect\\xE1ngulo 584",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_585",
    "data-name": "Rect\\xE1ngulo 585",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_586",
    "data-name": "Rect\\xE1ngulo 586",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_587",
    "data-name": "Rect\\xE1ngulo 587",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_588",
    "data-name": "Rect\\xE1ngulo 588",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_235",
    "data-name": "Grupo 235"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_589",
    "data-name": "Rect\\xE1ngulo 589",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_590",
    "data-name": "Rect\\xE1ngulo 590",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_591",
    "data-name": "Rect\\xE1ngulo 591",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_592",
    "data-name": "Rect\\xE1ngulo 592",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_593",
    "data-name": "Rect\\xE1ngulo 593",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_594",
    "data-name": "Rect\\xE1ngulo 594",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_595",
    "data-name": "Rect\\xE1ngulo 595",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_596",
    "data-name": "Rect\\xE1ngulo 596",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_240",
    "data-name": "Grupo 240",
    transform: "translate(271.668 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_237",
    "data-name": "Grupo 237",
    transform: "translate(90.556 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_597",
    "data-name": "Rect\\xE1ngulo 597",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_598",
    "data-name": "Rect\\xE1ngulo 598",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_599",
    "data-name": "Rect\\xE1ngulo 599",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_600",
    "data-name": "Rect\\xE1ngulo 600",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_601",
    "data-name": "Rect\\xE1ngulo 601",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_602",
    "data-name": "Rect\\xE1ngulo 602",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_603",
    "data-name": "Rect\\xE1ngulo 603",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_604",
    "data-name": "Rect\\xE1ngulo 604",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_238",
    "data-name": "Grupo 238",
    transform: "translate(181.112 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_605",
    "data-name": "Rect\\xE1ngulo 605",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_606",
    "data-name": "Rect\\xE1ngulo 606",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_607",
    "data-name": "Rect\\xE1ngulo 607",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_608",
    "data-name": "Rect\\xE1ngulo 608",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_609",
    "data-name": "Rect\\xE1ngulo 609",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_610",
    "data-name": "Rect\\xE1ngulo 610",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_611",
    "data-name": "Rect\\xE1ngulo 611",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_612",
    "data-name": "Rect\\xE1ngulo 612",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_239",
    "data-name": "Grupo 239",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_613",
    "data-name": "Rect\\xE1ngulo 613",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_614",
    "data-name": "Rect\\xE1ngulo 614",
    width: 22.639,
    height: 22.639,
    transform: "translate(90.556 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_615",
    "data-name": "Rect\\xE1ngulo 615",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_616",
    "data-name": "Rect\\xE1ngulo 616",
    width: 22.639,
    height: 22.639,
    transform: "translate(67.917 67.917) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_617",
    "data-name": "Rect\\xE1ngulo 617",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 0) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_618",
    "data-name": "Rect\\xE1ngulo 618",
    width: 22.639,
    height: 22.639,
    transform: "translate(45.278 45.278) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_619",
    "data-name": "Rect\\xE1ngulo 619",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 22.639) rotate(90)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_620",
    "data-name": "Rect\\xE1ngulo 620",
    width: 22.639,
    height: 22.639,
    transform: "translate(22.639 67.917) rotate(90)",
    fill: "#f2f2f2"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Componente_6_6",
    "data-name": "Componente 6 \\u2013 6",
    transform: "matrix(0.588, 0.809, -0.809, 0.588, 997.941, 525.259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_33",
    "data-name": "Elipse 33",
    cx: 171.503,
    cy: 171.503,
    r: 171.503,
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_249",
    "data-name": "Grupo 249",
    transform: "translate(22.296 21.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_248",
    "data-name": "Grupo 248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_177",
    "data-name": "Trazado 177",
    d: "M-1154.776,1815.831l1.093-2.569-.086-.037a8.449,8.449,0,0,1-4.13,1.3,8.79,8.79,0,0,1-3.594-.679,9.252,9.252,0,0,1-2.583-1.665,7.465,7.465,0,0,1-1.872-2.673,8.9,8.9,0,0,1-.641-3.692,13.009,13.009,0,0,1,1.171-4.748l5.186-12.195,3.44,1.463-5.074,11.933a8.153,8.153,0,0,0-.693,5.44,4.9,4.9,0,0,0,2.967,3.241,5.792,5.792,0,0,0,5.047-.013q2.345-1.164,3.9-4.822l4.742-11.148,3.442,1.463-8.873,20.861Z",
    transform: "translate(1356.153 -1774.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_178",
    "data-name": "Trazado 178",
    d: "M-1135.184,1800.559l-1.614,2.336.077.053a8.564,8.564,0,0,1,4.423-.367,9.581,9.581,0,0,1,3.5,1.468,10.017,10.017,0,0,1,2.293,2.218,7.59,7.59,0,0,1,1.374,3.049,9.246,9.246,0,0,1-.056,3.785,12.331,12.331,0,0,1-2.061,4.442l-7.5,10.864-3.076-2.125,7.368-10.67a7.971,7.971,0,0,0,1.734-5.216,5.243,5.243,0,0,0-2.45-3.9,6.208,6.208,0,0,0-5.153-1.116q-2.623.634-4.882,3.905l-6.857,9.928-3.077-2.125,12.882-18.651Z",
    transform: "translate(1360.322 -1771.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_179",
    "data-name": "Trazado 179",
    d: "M-1123.458,1840.448l2.21-2.071-.065-.07a11.149,11.149,0,0,1-4.233-.6,10.519,10.519,0,0,1-4.358-2.953,11.517,11.517,0,0,1-2.389-3.793,10.654,10.654,0,0,1-.7-4.342,12.1,12.1,0,0,1,1.1-4.434,12.977,12.977,0,0,1,3.027-4.1,12.931,12.931,0,0,1,4.087-2.631,11.872,11.872,0,0,1,4.429-.879,10.935,10.935,0,0,1,4.324.909,11.255,11.255,0,0,1,3.8,2.7,12.159,12.159,0,0,1,1.734,2.3,9.9,9.9,0,0,1,.933,2.206,9.059,9.059,0,0,1,.332,2.187,14.6,14.6,0,0,1-.1,2.207l.065.069,10.667-10,2.556,2.727-24.854,23.305Zm-4.761-16.943a8.359,8.359,0,0,0-.987,3.064,8.193,8.193,0,0,0,.3,3.258,7.773,7.773,0,0,0,1.874,3.14,7.9,7.9,0,0,0,2.619,1.859,8.314,8.314,0,0,0,3.091.7,8.3,8.3,0,0,0,3.233-.566,9.24,9.24,0,0,0,3.041-1.944,9.976,9.976,0,0,0,2.239-2.974,8.888,8.888,0,0,0,.872-3.186,7.468,7.468,0,0,0-.434-3.128,8.023,8.023,0,0,0-1.719-2.767,8.266,8.266,0,0,0-3.045-2.14,7.841,7.841,0,0,0-3.229-.54,8.332,8.332,0,0,0-3.123.788,10.274,10.274,0,0,0-2.72,1.837A10.28,10.28,0,0,0-1128.219,1823.5Z",
    transform: "translate(1365.219 -1767.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_180",
    "data-name": "Trazado 180",
    d: "M-1095.072,1843.529a10.694,10.694,0,0,1-.684,4.468,11.248,11.248,0,0,1-2.28,3.6,14.4,14.4,0,0,1-3.062,2.53c-.191.115-.41.236-.661.37a3.481,3.481,0,0,1-.565.255l-9.526-15.864a6.83,6.83,0,0,0-2.194,2.091,8.316,8.316,0,0,0-1.2,2.789,8.836,8.836,0,0,0-.145,3.068,7.432,7.432,0,0,0,1.024,2.945,7.225,7.225,0,0,0,2.351,2.536,7.948,7.948,0,0,0,3,1.042l2.217,3.693a12.607,12.607,0,0,1-2.59-.129,10.565,10.565,0,0,1-2.759-.827,11.28,11.28,0,0,1-2.691-1.725,11.191,11.191,0,0,1-2.319-2.8,12.442,12.442,0,0,1-1.722-4.706,10.96,10.96,0,0,1,.3-4.6,12.148,12.148,0,0,1,2.133-4.124,13.606,13.606,0,0,1,3.768-3.285,12.7,12.7,0,0,1,4.249-1.613,11.523,11.523,0,0,1,4.4.011,11.087,11.087,0,0,1,4.038,1.715,10.872,10.872,0,0,1,3.219,3.477A10.9,10.9,0,0,1-1095.072,1843.529Zm-6.483-5.6a7.226,7.226,0,0,0-2.456-1.146,7.125,7.125,0,0,0-2.634-.158,8.5,8.5,0,0,0-2.5.7l7.528,12.538a8.18,8.18,0,0,0,1.826-1.925,7.2,7.2,0,0,0,1.067-2.406,7.545,7.545,0,0,0,.132-2.675,6.915,6.915,0,0,0-.975-2.727A7.212,7.212,0,0,0-1101.554,1837.926Z",
    transform: "translate(1369.001 -1762.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_181",
    "data-name": "Trazado 181",
    d: "M-1089.281,1861.641a8.908,8.908,0,0,0-.394-1.192,5.828,5.828,0,0,0-1.261-1.97,4.694,4.694,0,0,0-2-1.2,7.169,7.169,0,0,0-2.785-.224,13.148,13.148,0,0,0-3.577.928l-11.18,4.413-1.373-3.478,21.085-8.322,1.373,3.478-2.641,1.043.034.088a6.091,6.091,0,0,1,1.427.327,6.344,6.344,0,0,1,1.564.806,8.242,8.242,0,0,1,1.458,1.308,6.107,6.107,0,0,1,1.1,1.829,11.129,11.129,0,0,1,.563,1.812l-3.214,1.269C-1089.141,1862.273-1089.2,1861.966-1089.281,1861.641Z",
    transform: "translate(1370.928 -1757.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_182",
    "data-name": "Trazado 182",
    d: "M-1086.75,1873.827a3.518,3.518,0,0,0,.281-2.5,3.681,3.681,0,0,0-1.492-2.394,2.879,2.879,0,0,0-2.286-.405,3.206,3.206,0,0,0-.951.4,2.347,2.347,0,0,0-.785.892,7.27,7.27,0,0,0-.609,1.628,13.813,13.813,0,0,0-.371,2.642,14.427,14.427,0,0,1-.63,3.385,8.093,8.093,0,0,1-1.194,2.349,5.919,5.919,0,0,1-1.658,1.514,7.178,7.178,0,0,1-2.042.825,6.379,6.379,0,0,1-5.339-.873,8.046,8.046,0,0,1-3.109-5,9.646,9.646,0,0,1-.259-3.344,7.048,7.048,0,0,1,.847-2.681,7.334,7.334,0,0,1,1.746-2.069,10.81,10.81,0,0,1,2.438-1.5l.875,3.683a5.111,5.111,0,0,0-2.186,1.955,4.339,4.339,0,0,0-.3,3.354,3.8,3.8,0,0,0,1.6,2.539,3.289,3.289,0,0,0,2.544.368,4.476,4.476,0,0,0,1.246-.49,2.911,2.911,0,0,0,.977-1.011,5.983,5.983,0,0,0,.674-1.765,20.088,20.088,0,0,0,.4-2.72,10.815,10.815,0,0,1,1.53-5.228,6,6,0,0,1,3.748-2.446,6.164,6.164,0,0,1,2.382-.1,5.521,5.521,0,0,1,2.222.857,6.475,6.475,0,0,1,1.826,1.853,8.711,8.711,0,0,1,1.195,2.877,8.546,8.546,0,0,1,.222,3.085,6.8,6.8,0,0,1-.8,2.475,6.957,6.957,0,0,1-1.566,1.905,10,10,0,0,1-2.128,1.38l-.875-3.683A3.848,3.848,0,0,0-1086.75,1873.827Z",
    transform: "translate(1372.171 -1754.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_183",
    "data-name": "Trazado 183",
    d: "M-1082.093,1882.248l7.208-.69.355,3.722-7.208.689.577,6.03-3.11.3-.577-6.03-11.919,1.138a10.47,10.47,0,0,0-2.264.431,3.3,3.3,0,0,0-1.374.8,2.412,2.412,0,0,0-.625,1.177,5.12,5.12,0,0,0-.063,1.575,10.312,10.312,0,0,0,.638,2.7l-3.062.293a11.208,11.208,0,0,1-.8-3.442,7.546,7.546,0,0,1,.316-3.406,4.883,4.883,0,0,1,1.554-2.145A6.713,6.713,0,0,1-1100,1884.2a18.791,18.791,0,0,1,3.016-.526l11.778-1.125-.283-2.969,3.11-.3Z",
    transform: "translate(1372.945 -1750.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_184",
    "data-name": "Trazado 184",
    d: "M-1104.513,1912.327l3.02.223.008-.1a11.226,11.226,0,0,1-2.422-3.5,10.048,10.048,0,0,1-.79-5.04,11.707,11.707,0,0,1,1.176-4.351,11.083,11.083,0,0,1,2.728-3.524,12.017,12.017,0,0,1,4.011-2.266,12.713,12.713,0,0,1,5.073-.574,12.752,12.752,0,0,1,4.747,1.253,11.391,11.391,0,0,1,3.638,2.784,11.556,11.556,0,0,1,2.224,3.938,12.084,12.084,0,0,1,.55,4.762,9.466,9.466,0,0,1-.584,2.757,10.944,10.944,0,0,1-1.107,2.149,9.241,9.241,0,0,1-1.4,1.651,13.6,13.6,0,0,1-1.514,1.218l0,.047,3.256.24-.275,3.729-22.607-1.672Zm9.249-15a8.035,8.035,0,0,0-2.922,1.326,8.107,8.107,0,0,0-2.2,2.447,8.069,8.069,0,0,0-1.048,3.577,7.649,7.649,0,0,0,.41,3.115,8.21,8.21,0,0,0,1.6,2.728,8.984,8.984,0,0,0,2.6,2.021,8.823,8.823,0,0,0,3.466.945,10.014,10.014,0,0,0,3.7-.367,8.664,8.664,0,0,0,2.939-1.539,7.753,7.753,0,0,0,2.006-2.438,7.717,7.717,0,0,0,.867-3.067,8.527,8.527,0,0,0-.48-3.761,7.425,7.425,0,0,0-1.813-2.744,8.868,8.868,0,0,0-2.719-1.743,10.168,10.168,0,0,0-3.148-.754A10.759,10.759,0,0,0-1095.264,1897.327Z",
    transform: "translate(1372.834 -1746.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_185",
    "data-name": "Trazado 185",
    d: "M-1083.711,1924.995l-2.723-.809-.028.092a8.572,8.572,0,0,1,1.723,4.09,9.56,9.56,0,0,1-.31,3.783,10.042,10.042,0,0,1-1.394,2.87,7.6,7.6,0,0,1-2.471,2.253,9.265,9.265,0,0,1-3.617,1.122,12.342,12.342,0,0,1-4.864-.581l-12.657-3.759,1.065-3.584,12.43,3.692a7.97,7.97,0,0,0,5.5.028,5.243,5.243,0,0,0,2.952-3.542,6.209,6.209,0,0,0-.54-5.245q-1.415-2.3-5.227-3.429l-11.569-3.437,1.064-3.584,21.732,6.455Z",
    transform: "translate(1371.413 -1740.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_186",
    "data-name": "Trazado 186",
    d: "M-1118.009,1949.007l2.651,1.463.046-.084a11.183,11.183,0,0,1-.73-4.212,10.524,10.524,0,0,1,1.466-5.055,11.533,11.533,0,0,1,2.873-3.441,10.616,10.616,0,0,1,3.915-2,12.1,12.1,0,0,1,4.556-.323,12.985,12.985,0,0,1,4.838,1.615,12.929,12.929,0,0,1,3.761,3.076,11.88,11.88,0,0,1,2.2,3.943,10.956,10.956,0,0,1,.467,4.394,11.252,11.252,0,0,1-1.4,4.443,12.044,12.044,0,0,1-1.652,2.358,9.919,9.919,0,0,1-1.811,1.568,9.088,9.088,0,0,1-1.979.99,14.74,14.74,0,0,1-2.131.582l-.046.082,12.8,7.064-1.807,3.272-29.833-16.46Zm14.651-9.753a8.351,8.351,0,0,0-3.22.006,8.165,8.165,0,0,0-3.007,1.288,7.777,7.777,0,0,0-2.409,2.75,7.867,7.867,0,0,0-.961,3.064,8.273,8.273,0,0,0,.284,3.156,8.3,8.3,0,0,0,1.534,2.9,9.279,9.279,0,0,0,2.788,2.295,10,10,0,0,0,3.52,1.212,8.9,8.9,0,0,0,3.3-.151,7.448,7.448,0,0,0,2.841-1.379,8.018,8.018,0,0,0,2.1-2.488,8.261,8.261,0,0,0,1.1-3.555,7.849,7.849,0,0,0-.482-3.24,8.362,8.362,0,0,0-1.712-2.728,10.331,10.331,0,0,0-2.585-2.022A10.359,10.359,0,0,0-1103.358,1939.254Z",
    transform: "translate(1368.778 -1735.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_187",
    "data-name": "Trazado 187",
    d: "M-1120.755,1958.9l-4.118-3.185,3.186-4.117,4.117,3.185Z",
    transform: "translate(1367.413 -1730.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_188",
    "data-name": "Trazado 188",
    d: "M-1119.3,1983.82a11.018,11.018,0,0,1-3.344.936,8.51,8.51,0,0,1-2.893-.16,8.487,8.487,0,0,1-2.2-.836l2.988-2.9a5.613,5.613,0,0,0,3.193.2,7.2,7.2,0,0,0,3.462-2.039,8.759,8.759,0,0,0,1.827-2.534,6.841,6.841,0,0,0,.681-2.968,8.3,8.3,0,0,0-.67-3.207,10.332,10.332,0,0,0-2.194-3.213,9.907,9.907,0,0,0-2.913-2.118,8.417,8.417,0,0,0-3.185-.8,7.926,7.926,0,0,0-3.17.5,8.168,8.168,0,0,0-2.838,1.831,6.284,6.284,0,0,0-2.113,3.667,7.386,7.386,0,0,0,.3,3.3l-2.988,2.9a10.751,10.751,0,0,1-.864-2.69,9.682,9.682,0,0,1-.071-3.064,10.738,10.738,0,0,1,1-3.247,11.609,11.609,0,0,1,2.458-3.276,12.683,12.683,0,0,1,4.107-2.734,11.714,11.714,0,0,1,4.5-.87,11.205,11.205,0,0,1,4.5,1,13.233,13.233,0,0,1,4.09,2.924,13.135,13.135,0,0,1,2.651,3.923,11.185,11.185,0,0,1,.955,4.414,11.349,11.349,0,0,1-.9,4.471,12.392,12.392,0,0,1-2.889,4.123A12.218,12.218,0,0,1-1119.3,1983.82Z",
    transform: "translate(1364.307 -1728.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_189",
    "data-name": "Trazado 189",
    d: "M-1138.194,1993.5a9.07,9.07,0,0,0,1.069-.657,5.835,5.835,0,0,0,1.628-1.679,4.7,4.7,0,0,0,.7-2.22,7.164,7.164,0,0,0-.422-2.762,13.22,13.22,0,0,0-1.726-3.267l-6.865-9.867,3.069-2.135,12.946,18.608-3.068,2.135-1.622-2.33-.079.053a6.134,6.134,0,0,1,.01,1.464,6.372,6.372,0,0,1-.425,1.708,8.309,8.309,0,0,1-.937,1.718,6.115,6.115,0,0,1-1.526,1.495,11.228,11.228,0,0,1-1.636.965l-1.972-2.836C-1138.777,1993.781-1138.494,1993.65-1138.194,1993.5Z",
    transform: "translate(1362.302 -1725.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_190",
    "data-name": "Trazado 190",
    d: "M-1151.517,2003.586a10.7,10.7,0,0,1-4.381-1.114,11.288,11.288,0,0,1-3.367-2.619,14.425,14.425,0,0,1-2.22-3.294q-.141-.3-.3-.695a3.586,3.586,0,0,1-.2-.585l16.713-7.942a6.809,6.809,0,0,0-1.868-2.386,8.307,8.307,0,0,0-2.659-1.462,8.786,8.786,0,0,0-3.039-.442,7.461,7.461,0,0,0-3.031.733,7.22,7.22,0,0,0-2.752,2.093,7.945,7.945,0,0,0-1.328,2.885l-3.89,1.848a12.535,12.535,0,0,1,.38-2.564,10.54,10.54,0,0,1,1.091-2.667,11.318,11.318,0,0,1,1.976-2.512,11.172,11.172,0,0,1,3.016-2.034,12.46,12.46,0,0,1,4.851-1.259,10.956,10.956,0,0,1,4.548.748,12.164,12.164,0,0,1,3.9,2.523,13.564,13.564,0,0,1,2.9,4.07,12.686,12.686,0,0,1,1.192,4.385,11.477,11.477,0,0,1-.437,4.373,11.057,11.057,0,0,1-2.1,3.853,10.844,10.844,0,0,1-3.773,2.867A10.9,10.9,0,0,1-1151.517,2003.586Zm6.2-5.908a7.255,7.255,0,0,0,1.38-2.333,7.121,7.121,0,0,0,.411-2.606,8.512,8.512,0,0,0-.456-2.56l-13.208,6.276a8.159,8.159,0,0,0,1.737,2,7.2,7.2,0,0,0,2.292,1.294,7.538,7.538,0,0,0,2.649.392,6.917,6.917,0,0,0,2.809-.706A7.206,7.206,0,0,0-1145.312,1997.678Z",
    transform: "translate(1356.895 -1723.059)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_191",
    "data-name": "Trazado 191",
    d: "M-1181.79,1989.456l.687,2.95.091-.021a11.256,11.256,0,0,1,2.62-3.355,10.062,10.062,0,0,1,4.577-2.257,11.692,11.692,0,0,1,4.5-.174,11.054,11.054,0,0,1,4.176,1.554,12,12,0,0,1,3.359,3.153,12.716,12.716,0,0,1,2.06,4.671,12.783,12.783,0,0,1,.218,4.906,11.4,11.4,0,0,1-1.573,4.3,11.578,11.578,0,0,1-3.095,3.3,12.1,12.1,0,0,1-4.382,1.943,9.434,9.434,0,0,1-2.805.265,10.981,10.981,0,0,1-2.381-.417,9.272,9.272,0,0,1-1.995-.847,13.668,13.668,0,0,1-1.612-1.082l-.047.01.74,3.181-3.641.847-5.14-22.076Zm17.073,4.357a8.031,8.031,0,0,0-2.136-2.394,8.127,8.127,0,0,0-2.991-1.369,8.053,8.053,0,0,0-3.726.066,7.657,7.657,0,0,0-2.852,1.321,8.177,8.177,0,0,0-2.126,2.342,8.953,8.953,0,0,0-1.153,3.087,8.78,8.78,0,0,0,.132,3.589,9.993,9.993,0,0,0,1.454,3.427,8.664,8.664,0,0,0,2.344,2.344,7.739,7.739,0,0,0,2.925,1.19,7.748,7.748,0,0,0,3.186-.086,8.543,8.543,0,0,0,3.447-1.58,7.4,7.4,0,0,0,2.079-2.549,8.873,8.873,0,0,0,.854-3.115,10.177,10.177,0,0,0-.218-3.229A10.763,10.763,0,0,0-1164.718,1993.814Z",
    transform: "translate(1351.068 -1721.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_192",
    "data-name": "Trazado 192",
    d: "M-1186.526,2012.254l.417,7.228-3.732.214-.417-7.228-6.047.348-.179-3.118,6.047-.349-.688-11.954a10.42,10.42,0,0,0-.344-2.278,3.337,3.337,0,0,0-.744-1.4,2.423,2.423,0,0,0-1.153-.668,5.11,5.11,0,0,0-1.571-.123,10.241,10.241,0,0,0-2.719.536l-.177-3.072a11.217,11.217,0,0,1,3.469-.673,7.547,7.547,0,0,1,3.391.445,4.887,4.887,0,0,1,2.085,1.634,6.732,6.732,0,0,1,1.092,2.5,19.023,19.023,0,0,1,.411,3.034l.68,11.812,2.977-.171.179,3.119Z",
    transform: "translate(1347.72 -1720.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_193",
    "data-name": "Trazado 193",
    d: "M-1212.9,2011.313a10.715,10.715,0,0,1-3.171-3.222,11.259,11.259,0,0,1-1.524-3.984,14.419,14.419,0,0,1-.194-3.967q.034-.33.1-.75a3.671,3.671,0,0,1,.132-.606l18.41,1.859a6.792,6.792,0,0,0-.362-3.01,8.3,8.3,0,0,0-1.519-2.626,8.834,8.834,0,0,0-2.371-1.952,7.457,7.457,0,0,0-2.973-.942,7.234,7.234,0,0,0-3.438.365,7.979,7.979,0,0,0-2.629,1.781l-4.286-.432a12.6,12.6,0,0,1,1.652-2,10.608,10.608,0,0,1,2.314-1.716,11.3,11.3,0,0,1,2.992-1.125,11.182,11.182,0,0,1,3.633-.18,12.436,12.436,0,0,1,4.8,1.436,10.937,10.937,0,0,1,3.5,2.993,12.145,12.145,0,0,1,2.027,4.177,13.546,13.546,0,0,1,.377,4.984,12.678,12.678,0,0,1-1.25,4.37,11.512,11.512,0,0,1-2.638,3.515,11.065,11.065,0,0,1-3.791,2.208,10.845,10.845,0,0,1-4.711.5A10.92,10.92,0,0,1-1212.9,2011.313Zm8.367-1.843a7.233,7.233,0,0,0,2.389-1.281,7.142,7.142,0,0,0,1.7-2.017,8.527,8.527,0,0,0,.935-2.426l-14.549-1.469a8.173,8.173,0,0,0,.45,2.614,7.2,7.2,0,0,0,1.29,2.295,7.552,7.552,0,0,0,2.063,1.707,6.907,6.907,0,0,0,2.768.85A7.191,7.191,0,0,0-1204.53,2009.47Z",
    transform: "translate(1342.318 -1720.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_194",
    "data-name": "Trazado 194",
    d: "M-1224.4,1991.718l1.258-5.052,5.052,1.259-1.259,5.052Z",
    transform: "translate(1340.549 -1721.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_195",
    "data-name": "Trazado 195",
    d: "M-1235.811,1981.58l-1.054,2.585.088.036a8.439,8.439,0,0,1,4.108-1.364,8.808,8.808,0,0,1,3.6.626,9.27,9.27,0,0,1,2.607,1.627,7.475,7.475,0,0,1,1.911,2.645,8.9,8.9,0,0,1,.695,3.683,13,13,0,0,1-1.1,4.763l-5.006,12.27-3.462-1.412,4.9-12.005a8.157,8.157,0,0,0,.612-5.449,4.9,4.9,0,0,0-3.013-3.2,5.8,5.8,0,0,0-5.046.089q-2.328,1.2-3.83,4.878l-4.577,11.217-3.462-1.412,8.563-20.989Z",
    transform: "translate(1334.224 -1722.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_196",
    "data-name": "Trazado 196",
    d: "M-1254.731,1997.465l1.578-2.359-.078-.053a8.573,8.573,0,0,1-4.418.432,9.567,9.567,0,0,1-3.521-1.417,10.007,10.007,0,0,1-2.327-2.183,7.56,7.56,0,0,1-1.419-3.028,9.259,9.259,0,0,1,0-3.787,12.336,12.336,0,0,1,1.995-4.472l7.344-10.974,3.108,2.08-7.212,10.777a7.971,7.971,0,0,0-1.656,5.241,5.243,5.243,0,0,0,2.507,3.869,6.212,6.212,0,0,0,5.17,1.04q2.612-.672,4.823-3.976l6.712-10.03,3.107,2.08-12.606,18.839Z",
    transform: "translate(1329.562 -1725.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_197",
    "data-name": "Trazado 197",
    d: "M-1264.775,1957.468l-2.179,2.1.065.068a11.191,11.191,0,0,1,4.241.544,10.51,10.51,0,0,1,4.4,2.889,11.518,11.518,0,0,1,2.443,3.759,10.633,10.633,0,0,1,.761,4.332,12.123,12.123,0,0,1-1.032,4.45,12.99,12.99,0,0,1-2.969,4.147,12.923,12.923,0,0,1-4.047,2.69,11.856,11.856,0,0,1-4.418.942,10.934,10.934,0,0,1-4.337-.846,11.266,11.266,0,0,1-3.835-2.645,12.056,12.056,0,0,1-1.768-2.274,9.983,9.983,0,0,1-.965-2.192,9.117,9.117,0,0,1-.363-2.183,14.921,14.921,0,0,1,.072-2.207l-.065-.069-10.522,10.157-2.6-2.691,24.517-23.664Zm5.006,16.873a8.329,8.329,0,0,0,.941-3.078,8.165,8.165,0,0,0-.344-3.253,7.8,7.8,0,0,0-1.919-3.113,7.907,7.907,0,0,0-2.645-1.821,8.319,8.319,0,0,0-3.1-.658,8.275,8.275,0,0,0-3.223.613,9.244,9.244,0,0,0-3.015,1.988,10,10,0,0,0-2.194,3.007,8.879,8.879,0,0,0-.827,3.2,7.456,7.456,0,0,0,.48,3.12,8.018,8.018,0,0,0,1.759,2.743,8.23,8.23,0,0,0,3.076,2.1,7.834,7.834,0,0,0,3.238.493,8.316,8.316,0,0,0,3.11-.832,10.324,10.324,0,0,0,2.695-1.877A10.343,10.343,0,0,0-1259.769,1974.341Z",
    transform: "translate(1322.334 -1729.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_198",
    "data-name": "Trazado 198",
    d: "M-1295.948,1953.84a10.692,10.692,0,0,1,.62-4.477,11.24,11.24,0,0,1,2.225-3.637,14.39,14.39,0,0,1,3.026-2.574c.188-.117.405-.242.655-.378a3.588,3.588,0,0,1,.56-.264l9.757,15.72a6.812,6.812,0,0,0,2.162-2.122,8.292,8.292,0,0,0,1.156-2.805,8.856,8.856,0,0,0,.1-3.07,7.46,7.46,0,0,0-1.067-2.929,7.223,7.223,0,0,0-2.387-2.5,7.944,7.944,0,0,0-3.013-1l-2.271-3.659a12.575,12.575,0,0,1,2.591.09,10.544,10.544,0,0,1,2.771.786,11.29,11.29,0,0,1,2.716,1.684,11.2,11.2,0,0,1,2.358,2.77,12.421,12.421,0,0,1,1.791,4.68,10.943,10.943,0,0,1-.235,4.6,12.138,12.138,0,0,1-2.072,4.154,13.558,13.558,0,0,1-3.719,3.339,12.684,12.684,0,0,1-4.224,1.675,11.5,11.5,0,0,1-4.4.053,11.044,11.044,0,0,1-4.062-1.656,10.846,10.846,0,0,1-3.269-3.427A10.9,10.9,0,0,1-1295.948,1953.84Zm6.563,5.506a7.249,7.249,0,0,0,2.473,1.111,7.1,7.1,0,0,0,2.635.119,8.5,8.5,0,0,0,2.493-.739l-7.709-12.425a8.122,8.122,0,0,0-1.8,1.95,7.193,7.193,0,0,0-1.031,2.422,7.568,7.568,0,0,0-.094,2.676,6.934,6.934,0,0,0,1.015,2.712A7.225,7.225,0,0,0-1289.385,1959.347Z",
    transform: "translate(1321.232 -1733.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_199",
    "data-name": "Trazado 199",
    d: "M-1301.578,1933.246a9.218,9.218,0,0,0,.411,1.186,5.838,5.838,0,0,0,1.29,1.952,4.7,4.7,0,0,0,2.015,1.166,7.174,7.174,0,0,0,2.787.183,13.146,13.146,0,0,0,3.562-.98l11.117-4.577,1.424,3.457-20.963,8.632-1.423-3.458,2.626-1.081-.037-.087a6.167,6.167,0,0,1-1.431-.306,6.363,6.363,0,0,1-1.576-.785,8.2,8.2,0,0,1-1.477-1.285,6.1,6.1,0,0,1-1.13-1.812,11.075,11.075,0,0,1-.589-1.8l3.2-1.316C-1301.727,1932.616-1301.66,1932.921-1301.578,1933.246Z",
    transform: "translate(1318.803 -1735.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_200",
    "data-name": "Trazado 200",
    d: "M-1304.7,1922.317a3.528,3.528,0,0,0-.245,2.5,3.676,3.676,0,0,0,1.529,2.371,2.872,2.872,0,0,0,2.291.372,3.208,3.208,0,0,0,.946-.41,2.35,2.35,0,0,0,.772-.9,7.41,7.41,0,0,0,.586-1.637,13.9,13.9,0,0,0,.331-2.648,14.394,14.394,0,0,1,.58-3.393,8.129,8.129,0,0,1,1.158-2.369,5.931,5.931,0,0,1,1.637-1.538,7.158,7.158,0,0,1,2.029-.855,6.376,6.376,0,0,1,5.35.792,8.048,8.048,0,0,1,3.184,4.955,9.6,9.6,0,0,1,.309,3.339,7.085,7.085,0,0,1-.806,2.695,7.362,7.362,0,0,1-1.716,2.094,10.859,10.859,0,0,1-2.417,1.54l-.931-3.67a5.125,5.125,0,0,0,2.159-1.988,4.338,4.338,0,0,0,.248-3.357,3.8,3.8,0,0,0-1.638-2.514,3.287,3.287,0,0,0-2.549-.332,4.461,4.461,0,0,0-1.238.509,2.888,2.888,0,0,0-.961,1.023,5.973,5.973,0,0,0-.649,1.776,19.986,19.986,0,0,0-.359,2.727,10.812,10.812,0,0,1-1.453,5.25,6,6,0,0,1-3.712,2.5,6.191,6.191,0,0,1-2.381.14,5.529,5.529,0,0,1-2.235-.825,6.535,6.535,0,0,1-1.854-1.825,8.761,8.761,0,0,1-1.237-2.86,8.564,8.564,0,0,1-.267-3.082,6.841,6.841,0,0,1,.761-2.488,6.973,6.973,0,0,1,1.539-1.927,9.958,9.958,0,0,1,2.107-1.412l.93,3.67A3.846,3.846,0,0,0-1304.7,1922.317Z",
    transform: "translate(1317.91 -1740.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_201",
    "data-name": "Trazado 201",
    d: "M-1308.258,1913.444l-7.2.794-.409-3.716,7.2-.793-.664-6.021,3.1-.343.664,6.021,11.9-1.312a10.446,10.446,0,0,0,2.258-.464,3.328,3.328,0,0,0,1.363-.817,2.439,2.439,0,0,0,.607-1.186,5.15,5.15,0,0,0,.041-1.576,10.252,10.252,0,0,0-.678-2.686l3.058-.338a11.256,11.256,0,0,1,.854,3.429,7.569,7.569,0,0,1-.267,3.41,4.888,4.888,0,0,1-1.524,2.168,6.7,6.7,0,0,1-2.436,1.221,18.87,18.87,0,0,1-3.007.57l-11.759,1.3.326,2.964-3.1.341Z",
    transform: "translate(1315.863 -1744.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_202",
    "data-name": "Trazado 202",
    d: "M-1287.445,1884.99l-3.022-.179-.006.094a11.246,11.246,0,0,1,2.474,3.466,10.072,10.072,0,0,1,.862,5.029,11.679,11.679,0,0,1-1.112,4.366,11.069,11.069,0,0,1-2.677,3.563,12,12,0,0,1-3.977,2.324,12.69,12.69,0,0,1-5.063.648,12.776,12.776,0,0,1-4.766-1.183,11.412,11.412,0,0,1-3.678-2.732,11.561,11.561,0,0,1-2.281-3.9,12.115,12.115,0,0,1-.619-4.753,9.487,9.487,0,0,1,.544-2.766,10.951,10.951,0,0,1,1.077-2.164,9.238,9.238,0,0,1,1.379-1.672,13.532,13.532,0,0,1,1.5-1.238l0-.047-3.26-.193.222-3.732,22.627,1.344Zm-9.028,15.132a8.02,8.02,0,0,0,2.9-1.369,8.115,8.115,0,0,0,2.163-2.479,8.063,8.063,0,0,0,.994-3.591,7.6,7.6,0,0,0-.455-3.107,8.211,8.211,0,0,0-1.641-2.705,8.937,8.937,0,0,0-2.632-1.981,8.764,8.764,0,0,0-3.478-.894,9.976,9.976,0,0,0-3.7.42,8.663,8.663,0,0,0-2.915,1.581,7.748,7.748,0,0,0-1.972,2.466,7.733,7.733,0,0,0-.822,3.08,8.536,8.536,0,0,0,.534,3.754,7.4,7.4,0,0,0,1.854,2.716,8.819,8.819,0,0,0,2.743,1.7,10.189,10.189,0,0,0,3.158.708A10.765,10.765,0,0,0-1296.473,1900.122Z",
    transform: "translate(1317.085 -1749.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_203",
    "data-name": "Trazado 203",
    d: "M-1307.785,1872.427l2.734.768.025-.091a8.563,8.563,0,0,1-1.783-4.065,9.587,9.587,0,0,1,.253-3.788,10.025,10.025,0,0,1,1.354-2.889,7.592,7.592,0,0,1,2.437-2.29,9.259,9.259,0,0,1,3.6-1.176,12.349,12.349,0,0,1,4.872.508l12.712,3.572-1.011,3.6-12.485-3.508a7.983,7.983,0,0,0-5.5.053,5.246,5.246,0,0,0-2.9,3.586,6.211,6.211,0,0,0,.617,5.237q1.451,2.274,5.278,3.35l11.618,3.265-1.011,3.6-21.825-6.131Z",
    transform: "translate(1317.771 -1755.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_204",
    "data-name": "Trazado 204",
    d: "M-1272.866,1849.98l-2.673-1.424-.044.084a11.145,11.145,0,0,1,.791,4.2,10.519,10.519,0,0,1-1.392,5.078A11.514,11.514,0,0,1-1279,1861.4a10.65,10.65,0,0,1-3.886,2.06,12.112,12.112,0,0,1-4.551.391,12.971,12.971,0,0,1-4.861-1.545,12.889,12.889,0,0,1-3.807-3.02,11.862,11.862,0,0,1-2.26-3.911,10.946,10.946,0,0,1-.532-4.386,11.257,11.257,0,0,1,1.332-4.465,12.108,12.108,0,0,1,1.618-2.382,10.008,10.008,0,0,1,1.788-1.595,9.124,9.124,0,0,1,1.964-1.018,14.712,14.712,0,0,1,2.122-.612l.044-.084-12.907-6.875,1.758-3.3,30.075,16.022Zm-14.507,9.969a8.335,8.335,0,0,0,3.219-.055,8.189,8.189,0,0,0,2.99-1.331,7.789,7.789,0,0,0,2.368-2.786,7.913,7.913,0,0,0,.917-3.078,8.356,8.356,0,0,0-.331-3.153,8.291,8.291,0,0,0-1.577-2.877,9.228,9.228,0,0,0-2.822-2.254,10.007,10.007,0,0,0-3.538-1.161,8.9,8.9,0,0,0-3.3.2,7.455,7.455,0,0,0-2.822,1.42,8.027,8.027,0,0,0-2.066,2.52,8.267,8.267,0,0,0-1.045,3.572,7.851,7.851,0,0,0,.531,3.232,8.342,8.342,0,0,0,1.751,2.7,10.331,10.331,0,0,0,2.616,1.984A10.331,10.331,0,0,0-1287.373,1859.949Z",
    transform: "translate(1319.351 -1763.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_205",
    "data-name": "Trazado 205",
    d: "M-1275.522,1834.564l4.164,3.124-3.125,4.164-4.164-3.125Z",
    transform: "translate(1325.908 -1762.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_206",
    "data-name": "Trazado 206",
    d: "M-1273.7,1813.272a11.031,11.031,0,0,1,3.331-.987,8.519,8.519,0,0,1,2.894.118,8.438,8.438,0,0,1,2.208.8l-2.945,2.944a5.609,5.609,0,0,0-3.2-.151,7.194,7.194,0,0,0-3.43,2.09,8.754,8.754,0,0,0-1.791,2.56,6.861,6.861,0,0,0-.636,2.978,8.288,8.288,0,0,0,.719,3.2,10.248,10.248,0,0,0,2.24,3.18,9.871,9.871,0,0,0,2.945,2.075,8.4,8.4,0,0,0,3.2.754,7.942,7.942,0,0,0,3.163-.551,8.191,8.191,0,0,0,2.81-1.873,6.292,6.292,0,0,0,2.06-3.7,7.368,7.368,0,0,0-.352-3.3l2.946-2.945a10.807,10.807,0,0,1,.9,2.677,9.645,9.645,0,0,1,.116,3.062,10.757,10.757,0,0,1-.954,3.262,11.65,11.65,0,0,1-2.41,3.313,12.694,12.694,0,0,1-4.066,2.792,11.692,11.692,0,0,1-4.484.936,11.148,11.148,0,0,1-4.517-.937,13.192,13.192,0,0,1-4.132-2.862,13.1,13.1,0,0,1-2.71-3.882,11.165,11.165,0,0,1-1.02-4.4,11.334,11.334,0,0,1,.838-4.484,12.375,12.375,0,0,1,2.828-4.165A12.154,12.154,0,0,1-1273.7,1813.272Z",
    transform: "translate(1325.323 -1768.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_207",
    "data-name": "Trazado 207",
    d: "M-1256.693,1803.645a9.191,9.191,0,0,0-1.059.674,5.846,5.846,0,0,0-1.6,1.7,4.708,4.708,0,0,0-.671,2.23,7.161,7.161,0,0,0,.462,2.754,13.161,13.161,0,0,0,1.774,3.242l7.009,9.767-3.038,2.179-13.218-18.416,3.037-2.181,1.656,2.308.076-.056a6.22,6.22,0,0,1-.03-1.463,6.364,6.364,0,0,1,.4-1.714,8.2,8.2,0,0,1,.912-1.732,6.082,6.082,0,0,1,1.5-1.516,11.105,11.105,0,0,1,1.62-.989l2.016,2.807Q-1256.247,1803.414-1256.693,1803.645Z",
    transform: "translate(1329.042 -1771.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_208",
    "data-name": "Trazado 208",
    d: "M-1241.856,1792.965a10.686,10.686,0,0,1,4.4,1.05,11.268,11.268,0,0,1,3.4,2.569,14.369,14.369,0,0,1,2.268,3.261c.1.2.2.428.314.689a3.719,3.719,0,0,1,.21.583l-16.6,8.186a6.809,6.809,0,0,0,1.9,2.359,8.289,8.289,0,0,0,2.679,1.422,8.849,8.849,0,0,0,3.045.4,7.465,7.465,0,0,0,3.021-.777,7.227,7.227,0,0,0,2.72-2.133,7.958,7.958,0,0,0,1.286-2.9l3.862-1.9a12.471,12.471,0,0,1-.342,2.569,10.529,10.529,0,0,1-1.052,2.682,11.274,11.274,0,0,1-1.94,2.54,11.188,11.188,0,0,1-2.986,2.08,12.423,12.423,0,0,1-4.832,1.327,10.941,10.941,0,0,1-4.558-.681,12.147,12.147,0,0,1-3.934-2.466,13.574,13.574,0,0,1-2.962-4.027,12.658,12.658,0,0,1-1.257-4.366,11.5,11.5,0,0,1,.373-4.38,11.039,11.039,0,0,1,2.042-3.882,10.83,10.83,0,0,1,3.73-2.922A10.9,10.9,0,0,1-1241.856,1792.965Zm-6.117,6a7.247,7.247,0,0,0-1.346,2.352,7.116,7.116,0,0,0-.374,2.612,8.48,8.48,0,0,0,.494,2.554l13.116-6.469a8.136,8.136,0,0,0-1.768-1.979,7.176,7.176,0,0,0-2.311-1.261,7.527,7.527,0,0,0-2.654-.353,6.9,6.9,0,0,0-2.8.746A7.2,7.2,0,0,0-1247.973,1798.964Z",
    transform: "translate(1332.758 -1773.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_209",
    "data-name": "Trazado 209",
    d: "M-1210.927,1807.077l-.73-2.94-.093.023a11.26,11.26,0,0,1-2.569,3.395,10.084,10.084,0,0,1-4.544,2.324,11.71,11.71,0,0,1-4.5.24,11.068,11.068,0,0,1-4.2-1.492,12.006,12.006,0,0,1-3.4-3.1,12.7,12.7,0,0,1-2.128-4.639,12.761,12.761,0,0,1-.291-4.9,11.35,11.35,0,0,1,1.51-4.325,11.572,11.572,0,0,1,3.045-3.341,12.119,12.119,0,0,1,4.353-2.009,9.538,9.538,0,0,1,2.8-.306,11.087,11.087,0,0,1,2.386.382,9.257,9.257,0,0,1,2.008.818,13.848,13.848,0,0,1,1.629,1.058l.046-.01-.787-3.17,3.628-.9,5.467,22Zm-17.137-4.1a8.011,8.011,0,0,0,2.173,2.361,8.1,8.1,0,0,0,3.01,1.324,8.053,8.053,0,0,0,3.726-.121,7.619,7.619,0,0,0,2.83-1.363,8.177,8.177,0,0,0,2.093-2.372,8.971,8.971,0,0,0,1.106-3.1,8.8,8.8,0,0,0-.184-3.588,10.011,10.011,0,0,0-1.5-3.4,8.681,8.681,0,0,0-2.379-2.311,7.785,7.785,0,0,0-2.942-1.145,7.728,7.728,0,0,0-3.186.133,8.536,8.536,0,0,0-3.422,1.631,7.4,7.4,0,0,0-2.041,2.58,8.862,8.862,0,0,0-.808,3.126,10.186,10.186,0,0,0,.266,3.226A10.788,10.788,0,0,0-1228.064,1802.973Z",
    transform: "translate(1338.093 -1775.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_210",
    "data-name": "Trazado 210",
    d: "M-1209.007,1785.069l-.523-7.222,3.729-.271.523,7.223,6.042-.438.225,3.116-6.042.437.865,11.942a10.464,10.464,0,0,0,.377,2.274,3.326,3.326,0,0,0,.766,1.392,2.432,2.432,0,0,0,1.162.652,5.146,5.146,0,0,0,1.573.1,10.244,10.244,0,0,0,2.71-.575l.222,3.068a11.185,11.185,0,0,1-3.459.725,7.542,7.542,0,0,1-3.4-.4,4.884,4.884,0,0,1-2.109-1.6,6.709,6.709,0,0,1-1.129-2.48,18.949,18.949,0,0,1-.456-3.027l-.853-11.8-2.974.216-.225-3.116Z",
    transform: "translate(1343.902 -1777.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_211",
    "data-name": "Trazado 211",
    d: "M-1180.913,1784.406a10.693,10.693,0,0,1,3.218,3.175,11.254,11.254,0,0,1,1.584,3.959,14.438,14.438,0,0,1,.251,3.965c-.019.22-.048.471-.089.752a3.5,3.5,0,0,1-.123.607l-18.434-1.587a6.8,6.8,0,0,0,.406,3,8.291,8.291,0,0,0,1.557,2.6,8.82,8.82,0,0,0,2.4,1.917,7.475,7.475,0,0,0,2.987.9,7.221,7.221,0,0,0,3.431-.418,7.962,7.962,0,0,0,2.6-1.817l4.291.368a12.514,12.514,0,0,1-1.623,2.022,10.528,10.528,0,0,1-2.288,1.75,11.239,11.239,0,0,1-2.974,1.169,11.206,11.206,0,0,1-3.631.234,12.459,12.459,0,0,1-4.822-1.365,10.955,10.955,0,0,1-3.547-2.941,12.175,12.175,0,0,1-2.089-4.146,13.547,13.547,0,0,1-.45-4.979,12.658,12.658,0,0,1,1.185-4.386,11.523,11.523,0,0,1,2.586-3.553,11.059,11.059,0,0,1,3.758-2.264,10.83,10.83,0,0,1,4.7-.569A10.9,10.9,0,0,1-1180.913,1784.406Zm-8.338,1.966a7.225,7.225,0,0,0-2.37,1.317,7.145,7.145,0,0,0-1.672,2.041,8.454,8.454,0,0,0-.9,2.439l14.568,1.255a8.157,8.157,0,0,0-.488-2.607,7.209,7.209,0,0,0-1.324-2.276,7.53,7.53,0,0,0-2.088-1.675,6.9,6.9,0,0,0-2.781-.809A7.2,7.2,0,0,0-1189.251,1786.372Z",
    transform: "translate(1347.591 -1776.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_212",
    "data-name": "Trazado 212",
    d: "M-1172.583,1800.026l-1.185,5.069-5.068-1.185,1.185-5.07Z",
    transform: "translate(1352.848 -1771.837)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_283",
    "data-name": "Grupo 283",
    transform: "translate(1327.581 638.802)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_629",
    "data-name": "Rect\\xE1ngulo 629",
    width: 256.71,
    height: 459.743,
    transform: "translate(169.943 192.853)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_40",
    "data-name": "L\\xEDnea 40",
    x2: 256.71,
    transform: "translate(170.265 228.59)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_279",
    "data-name": "Grupo 279",
    transform: "translate(180.568 203.404)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_37",
    "data-name": "Elipse 37",
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_38",
    "data-name": "Elipse 38",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(5.483 5.483)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_280",
    "data-name": "Grupo 280",
    transform: "translate(202.234 203.404)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_39",
    "data-name": "Elipse 39",
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_41",
    "data-name": "L\\xEDnea 41",
    x2: 7.208,
    transform: "translate(3.222 6.826)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_282",
    "data-name": "Grupo 282",
    transform: "translate(234.032 203.404)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_281",
    "data-name": "Grupo 281",
    transform: "translate(2.816 2.816)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_42",
    "data-name": "L\\xEDnea 42",
    y2: 8.02,
    transform: "translate(4.01)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_43",
    "data-name": "L\\xEDnea 43",
    x1: 8.02,
    transform: "translate(0 4.01)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_310",
    "data-name": "Grupo 310",
    transform: "translate(958.416 431.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_629-2",
    "data-name": "Rect\\xE1ngulo 629",
    width: 587.235,
    height: 459.743,
    transform: "translate(169.943 192.853)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_40-2",
    "data-name": "L\\xEDnea 40",
    x2: 587.235,
    transform: "translate(170.265 228.59)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_279-2",
    "data-name": "Grupo 279"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_37-2",
    "data-name": "Elipse 37",
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    transform: "translate(180.568 203.404)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_38-2",
    "data-name": "Elipse 38",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(186.051 208.887)",
    fill: "#fffaf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_280-2",
    "data-name": "Grupo 280"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_39-2",
    "data-name": "Elipse 39",
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    transform: "translate(202.234 203.404)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_41-2",
    "data-name": "L\\xEDnea 41",
    x2: 7.208,
    transform: "translate(205.456 210.23)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_282-2",
    "data-name": "Grupo 282"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40-2",
    "data-name": "Elipse 40",
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    transform: "translate(223.901 203.404)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_281-2",
    "data-name": "Grupo 281"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_42-2",
    "data-name": "L\\xEDnea 42",
    y2: 8.02,
    transform: "translate(230.727 206.22)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_43-2",
    "data-name": "L\\xEDnea 43",
    x1: 8.02,
    transform: "translate(226.717 210.23)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_288",
    "data-name": "Grupo 288",
    transform: "translate(998.137 600.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1661",
    "data-name": "Grupo 1661",
    transform: "translate(-157 -34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_630",
    "data-name": "Rect\\xE1ngulo 630",
    width: 587.235,
    height: 459.743,
    transform: "translate(131.5 164)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_44",
    "data-name": "L\\xEDnea 44",
    x2: 587.235,
    transform: "translate(131.822 199.736)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_284",
    "data-name": "Grupo 284",
    transform: "translate(4.391)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_41",
    "data-name": "Elipse 41",
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    transform: "translate(142.124 174.55)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_42",
    "data-name": "Elipse 42",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(147.608 180.034)",
    fill: "#fffaf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_285",
    "data-name": "Grupo 285",
    transform: "translate(4.391)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_43",
    "data-name": "Elipse 43",
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    transform: "translate(163.791 174.55)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_45",
    "data-name": "L\\xEDnea 45",
    x2: 7.208,
    transform: "translate(167.013 181.376)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_287",
    "data-name": "Grupo 287",
    transform: "translate(4.391)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    "data-name": "Elipse 44",
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    transform: "translate(185.457 174.55)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_286",
    "data-name": "Grupo 286"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_46",
    "data-name": "L\\xEDnea 46",
    y2: 8.02,
    transform: "translate(192.283 177.366)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_47",
    "data-name": "L\\xEDnea 47",
    x1: 8.02,
    transform: "translate(188.273 181.376)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_298",
    "data-name": "Grupo 298",
    transform: "translate(869.854 670.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_278",
    "data-name": "Trazado 278",
    d: "M301.977,458.589l30.459-39.158L330.6,469.007l48.5-10.418-33.273,36.8,43.852,23.2-49.141,6.8L398.03,605.52l-80.824-60.56-15.23,47.214-15.23-47.214-42.015,26.378,18.682-45.957-49.141-6.8,43.852-23.2-33.273-36.8,48.5,10.418-1.837-49.575Z",
    fill: "#ffc0d4",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_289",
    "data-name": "Grupo 289"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_631",
    "data-name": "Rect\\xE1ngulo 631",
    width: 10.948,
    height: 10.948,
    transform: "translate(325.75 418.085)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_632",
    "data-name": "Rect\\xE1ngulo 632",
    width: 10.218,
    height: 10.218,
    transform: "translate(325.02 417.355)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_290",
    "data-name": "Grupo 290"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_633",
    "data-name": "Rect\\xE1ngulo 633",
    width: 10.948,
    height: 10.948,
    transform: "translate(266.32 414.175)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_634",
    "data-name": "Rect\\xE1ngulo 634",
    width: 10.218,
    height: 10.218,
    transform: "translate(265.59 413.445)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_291",
    "data-name": "Grupo 291"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_635",
    "data-name": "Rect\\xE1ngulo 635",
    width: 10.948,
    height: 10.948,
    transform: "translate(220.184 455.62)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_636",
    "data-name": "Rect\\xE1ngulo 636",
    width: 10.218,
    height: 10.218,
    transform: "translate(219.454 454.89)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_292",
    "data-name": "Grupo 292"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_637",
    "data-name": "Rect\\xE1ngulo 637",
    width: 10.948,
    height: 10.948,
    transform: "translate(209.236 511.139)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_638",
    "data-name": "Rect\\xE1ngulo 638",
    width: 10.218,
    height: 10.218,
    transform: "translate(208.506 510.41)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_293",
    "data-name": "Grupo 293"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_639",
    "data-name": "Rect\\xE1ngulo 639",
    width: 10.948,
    height: 10.948,
    transform: "translate(238.951 565.095)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_640",
    "data-name": "Rect\\xE1ngulo 640",
    width: 10.218,
    height: 10.218,
    transform: "translate(238.221 564.365)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_294",
    "data-name": "Grupo 294"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_641",
    "data-name": "Rect\\xE1ngulo 641",
    width: 10.948,
    height: 10.948,
    transform: "translate(297.599 587.773)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_642",
    "data-name": "Rect\\xE1ngulo 642",
    width: 10.218,
    height: 10.218,
    transform: "translate(296.869 587.043)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_295",
    "data-name": "Grupo 295"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_643",
    "data-name": "Rect\\xE1ngulo 643",
    width: 10.948,
    height: 10.948,
    transform: "translate(393.008 600.078)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_644",
    "data-name": "Rect\\xE1ngulo 644",
    width: 10.218,
    height: 10.218,
    transform: "translate(392.278 599.348)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_296",
    "data-name": "Grupo 296"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_645",
    "data-name": "Rect\\xE1ngulo 645",
    width: 10.948,
    height: 10.948,
    transform: "translate(382.834 513.485)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_646",
    "data-name": "Rect\\xE1ngulo 646",
    width: 10.218,
    height: 10.218,
    transform: "translate(382.104 512.755)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_297",
    "data-name": "Grupo 297"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_647",
    "data-name": "Rect\\xE1ngulo 647",
    width: 10.948,
    height: 10.948,
    transform: "translate(373.45 454.838)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_648",
    "data-name": "Rect\\xE1ngulo 648",
    width: 10.218,
    height: 10.218,
    transform: "translate(372.72 454.108)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_308",
    "data-name": "Grupo 308",
    transform: "translate(989.431 414.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_48",
    "data-name": "Elipse 48",
    cx: 2.501,
    cy: 2.501,
    r: 2.501,
    transform: "translate(806.949 75.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_49",
    "data-name": "Elipse 49",
    cx: 2.501,
    cy: 2.501,
    r: 2.501,
    transform: "translate(571.177 75.605)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_51",
    "data-name": "L\\xEDnea 51",
    x2: 235.102,
    transform: "translate(573.916 78.105)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_307",
    "data-name": "Grupo 307",
    transform: "translate(558.094 71.214)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_50",
    "data-name": "Elipse 50",
    cx: 124.316,
    cy: 124.316,
    r: 124.316,
    transform: "translate(8.344 8.08)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_303",
    "data-name": "Grupo 303",
    transform: "translate(124.316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_650",
    "data-name": "Rect\\xE1ngulo 650",
    width: 15.644,
    height: 15.644,
    transform: "translate(1.043 1.043)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_651",
    "data-name": "Rect\\xE1ngulo 651",
    width: 14.601,
    height: 14.601,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_304",
    "data-name": "Grupo 304",
    transform: "translate(124.316 247.203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_652",
    "data-name": "Rect\\xE1ngulo 652",
    width: 15.644,
    height: 15.644,
    transform: "translate(1.043 1.043)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_653",
    "data-name": "Rect\\xE1ngulo 653",
    width: 14.601,
    height: 14.601,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_305",
    "data-name": "Grupo 305",
    transform: "translate(250.06 124.052)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_654",
    "data-name": "Rect\\xE1ngulo 654",
    width: 15.644,
    height: 15.644,
    transform: "translate(1.043 1.043)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_655",
    "data-name": "Rect\\xE1ngulo 655",
    width: 14.601,
    height: 14.601,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_306",
    "data-name": "Grupo 306",
    transform: "translate(0 124.052)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_656",
    "data-name": "Rect\\xE1ngulo 656",
    width: 15.644,
    height: 15.644,
    transform: "translate(1.043 1.043)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_657",
    "data-name": "Rect\\xE1ngulo 657",
    width: 14.601,
    height: 14.601,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_342",
    "data-name": "Grupo 342",
    transform: "translate(60.521 243.228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_668",
    "data-name": "Rect\\xE1ngulo 668",
    width: 386.814,
    height: 179.029,
    transform: "translate(191.445 262.988)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    "data-name": "Grupo 332",
    transform: "translate(191.445 297.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_324",
    "data-name": "Grupo 324",
    transform: "translate(-18.609 6.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_303",
    "data-name": "Trazado 303",
    d: "M372.981,391.275,411.6,595.957H259.7l-7.725-306.379c30.9-21.885,73.378,0,95.262,23.17,30.516,32.312,25.746,78.527,25.746,78.527",
    transform: "translate(-107.243 -280.546)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_304",
    "data-name": "Trazado 304",
    d: "M418.523,526.442l-152.546-.175c-121.007-16.736-69.516-175.074-69.516-175.074L371.64,382.352Z",
    transform: "translate(-172.739 -210.856)",
    fill: "#edaa00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_305",
    "data-name": "Trazado 305",
    d: "M337.074,507.218,318.432,401.109l-78.459-2.548L225.079,508.505",
    transform: "translate(-133.772 -164.129)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_306",
    "data-name": "Trazado 306",
    d: "M316.846,439.649l-7.723-47.629H234.553l-2.67,23.172S264.066,457.672,316.846,439.649Z",
    transform: "translate(-127.06 -170.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_307",
    "data-name": "Trazado 307",
    d: "M197.058,430.594a112.355,112.355,0,1,0-2.91-44.453",
    transform: "translate(-164.284 -272.384)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_308",
    "data-name": "Trazado 308",
    d: "M207.071,351.147s-42.21,44.5-22.9,115.306",
    transform: "translate(-179.114 -210.901)",
    fill: "none",
    stroke: "#edaa00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_309",
    "data-name": "Trazado 309",
    d: "M328.4,327.08s-20.6-25.746-54.067-16.736",
    transform: "translate(-85.188 -253.038)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_310",
    "data-name": "Trazado 310",
    d: "M271.4,314.94s-32.9-19.437-61.224,12.745",
    transform: "translate(-148.475 -252.356)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_311",
    "data-name": "Trazado 311",
    d: "M196.978,375.344c48.076-140.734,121.4-81.518,121.4-81.518s-22.306,88.274-125.5,124.419l-.288-6.607a107.52,107.52,0,0,1,2.708-29.084Z",
    transform: "translate(-165.92 -279.644)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_312",
    "data-name": "Trazado 312",
    d: "M242.914,367.748a16.346,16.346,0,0,0,18.067,14.418",
    transform: "translate(-116.178 -194.525)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_313",
    "data-name": "Trazado 313",
    d: "M393.055,372.455c-89.372-2.769-137.194-84.77-137.194-84.77",
    transform: "translate(-103.407 -273.503)",
    fill: "none",
    stroke: "#fd0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_57",
    "data-name": "L\\xEDnea 57",
    x2: 6.017,
    y2: 91.659,
    transform: "translate(158.569 66.047)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    "data-name": "Grupo 327",
    transform: "translate(284.46 88.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    "data-name": "Grupo 325",
    transform: "translate(18.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_314",
    "data-name": "Trazado 314",
    d: "M355.44,425.356a14.468,14.468,0,0,1-7.693-18.577l14.1-37.073-18.174-24.547a14.739,14.739,0,0,1,2.976-20.409,14.215,14.215,0,0,1,20.129,2.757L389.7,358.47a14.638,14.638,0,0,1,1.845,13.961l-17,44.622a14.5,14.5,0,0,1-18.641,8.49C355.748,425.481,355.593,425.419,355.44,425.356Z",
    transform: "translate(-340.837 -321.77)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    "data-name": "Grupo 326",
    transform: "translate(0 1.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_315",
    "data-name": "Trazado 315",
    d: "M382.712,418.1A15.363,15.363,0,0,1,364.7,430.252c-.177-.034-.352-.072-.524-.111a15.362,15.362,0,0,1-11.627-17.9l7.8-41-23.794-22.22a15.364,15.364,0,0,1,20.973-22.457l30.013,28.029",
    transform: "translate(-331.682 -322.421)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330",
    transform: "translate(23.273 88.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_328",
    "data-name": "Grupo 328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_316",
    "data-name": "Trazado 316",
    d: "M237.3,425.356a14.468,14.468,0,0,0,7.694-18.577l-14.1-37.073,18.174-24.547a14.739,14.739,0,0,0-2.976-20.409,14.215,14.215,0,0,0-20.129,2.757L203.033,358.47a14.638,14.638,0,0,0-1.845,13.961l17,44.622a14.5,14.5,0,0,0,18.641,8.49C236.989,425.481,237.144,425.419,237.3,425.356Z",
    transform: "translate(-200.198 -321.77)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329",
    transform: "translate(14.025 1.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_317",
    "data-name": "Trazado 317",
    d: "M212.091,418.1A15.363,15.363,0,0,0,230.1,430.252c.177-.034.352-.072.524-.111a15.362,15.362,0,0,0,11.627-17.9l-7.8-41,23.794-22.22a15.364,15.364,0,0,0-20.973-22.457l-30.013,28.029",
    transform: "translate(-207.258 -322.421)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_337",
    "data-name": "Grupo 337",
    transform: "translate(254.258 362.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_336",
    "data-name": "Grupo 336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_319",
    "data-name": "Trazado 319",
    d: "M264.365,336.755,359.328,310l-1.245,39.716-68.673,13.94Z",
    transform: "translate(-176.441 -309.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_320",
    "data-name": "Trazado 320",
    d: "M277.136,430.453a57.034,57.034,0,0,1,0-114.068",
    transform: "translate(-220.103 -303.7)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_321",
    "data-name": "Trazado 321",
    d: "M289.455,398.342,320,427.112,344.624,311.5l-74.757,20.552",
    transform: "translate(-171.014 -308.519)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_53",
    "data-name": "Elipse 53",
    cx: 68.46,
    cy: 68.46,
    r: 68.46,
    transform: "translate(127.131)",
    fill: "#0067ec",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    "data-name": "Grupo 333",
    transform: "translate(133.005 32.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_322",
    "data-name": "Trazado 322",
    d: "M413.129,362.441a73.188,73.188,0,0,0-126.066,0l0,0a73.189,73.189,0,0,0,126.076,0",
    transform: "translate(-287.059 -326.447)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_54",
    "data-name": "Elipse 54",
    cx: 57.034,
    cy: 57.034,
    r: 57.034,
    transform: "translate(8.093 12.497)",
    fill: "#0067ec",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_334",
    "data-name": "Grupo 334",
    transform: "translate(12.612 39.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_323",
    "data-name": "Trazado 323",
    d: "M331.478,359.98a60.97,60.97,0,0,0-105.024,0h0a60.97,60.97,0,0,0,105.03,0",
    transform: "translate(-226.452 -329.993)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_55",
    "data-name": "Elipse 55",
    cx: 28.58,
    cy: 28.58,
    r: 28.58,
    transform: "translate(431.21 403.069)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_56",
    "data-name": "Elipse 56",
    cx: 26.086,
    cy: 26.086,
    r: 26.086,
    transform: "translate(297.791 407.11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_338",
    "data-name": "Grupo 338",
    transform: "translate(563.936 430.727)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_669",
    "data-name": "Rect\\xE1ngulo 669",
    width: 17.908,
    height: 17.908,
    transform: "translate(1.194 1.194)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_670",
    "data-name": "Rect\\xE1ngulo 670",
    width: 16.714,
    height: 16.714,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_339",
    "data-name": "Grupo 339",
    transform: "translate(563.936 256.422)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_671",
    "data-name": "Rect\\xE1ngulo 671",
    width: 17.908,
    height: 17.908,
    transform: "translate(1.194 1.194)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_672",
    "data-name": "Rect\\xE1ngulo 672",
    width: 16.714,
    height: 16.714,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_340",
    "data-name": "Grupo 340",
    transform: "translate(185.479 430.727)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_673",
    "data-name": "Rect\\xE1ngulo 673",
    width: 17.908,
    height: 17.908,
    transform: "translate(1.194 1.194)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_674",
    "data-name": "Rect\\xE1ngulo 674",
    width: 16.714,
    height: 16.714,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_341",
    "data-name": "Grupo 341",
    transform: "translate(185.479 256.422)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_675",
    "data-name": "Rect\\xE1ngulo 675",
    width: 17.908,
    height: 17.908,
    transform: "translate(1.194 1.194)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_676",
    "data-name": "Rect\\xE1ngulo 676",
    width: 17,
    height: 17,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_344",
    "data-name": "Grupo 344",
    transform: "translate(84.5 433.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_649",
    "data-name": "Rect\\xE1ngulo 649",
    width: 55,
    height: 307,
    transform: "translate(55.5 107.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "eyedropper-4",
    d: "M91.508,262.845a2.218,2.218,0,0,0-.009,3.133l-1.572,1.56-7.795-7.861L83.7,258.12a2.211,2.211,0,0,0,3.128.01l4.123-4a3.322,3.322,0,1,1,4.681,4.716Zm-8.425-.9L72.806,272.005c-1.509,1.488-.339,2.489-1.538,4.4a1.6,1.6,0,0,0-.264.757,1.271,1.271,0,0,0,1.186,1.348,1.309,1.309,0,0,0,.816-.236c2-1.355,2.933-.028,4.478-1.56l11.123-10.362M71.125,282.613c-.544,2.8-2.281,3.291-2.167,5.1A2.476,2.476,0,0,0,73.9,287.4C73.785,285.593,72.017,285.324,71.125,282.613Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_299",
    "data-name": "Grupo 299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pen-14",
    d: "M82.809,210.2s2.594-4.795,4.2-7.9l10.284,10.284c-3.12,1.6-7.922,4.179-7.922,4.179ZM69.586,229.64l1.628,1.659c4-2.577,10.4-4.242,10.4-4.242l5.151-9.47-4.775-4.774-9.469,5.15s-1.619,6.349-4.225,10.4l1.294,1.282",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_45",
    "data-name": "Elipse 45",
    cx: 1.116,
    cy: 1.116,
    r: 1.116,
    transform: "translate(75.724 221.27)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_48",
    "data-name": "L\\xEDnea 48",
    x1: 6.696,
    y2: 6.586,
    transform: "translate(69.586 223.055)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_49",
    "data-name": "L\\xEDnea 49",
    x2: 55,
    transform: "translate(55.5 126.5)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_300",
    "data-name": "Grupo 300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cut-1",
    d: "M84.144,328.275c-4.686,2.29-11.468,5.828-12.7,6.419-2.48,1.192-4.753-1.939-4.753-1.939L79.7,326.483m13.762,11.959a6.345,6.345,0,0,1-2.77-.642,5.862,5.862,0,0,1-3.351-6.511c.348-1.419-.4-1.612-1.537-2.163l-19.035-9.212s2.28-3.125,4.758-1.927c1.521.737,7.631,3.685,12.9,6.24l1.322-.635c1.14-.549,1.887-.741,1.542-2.159a5.86,5.86,0,0,1,3.367-6.5,6.37,6.37,0,0,1,2.757-.636,5.2,5.2,0,0,1,5.427,5.1,6.127,6.127,0,0,1-3.505,5.331c-2.182,1.1-3.711.242-5.876,1.294l-.678.329.741.362c2.164,1.059,3.694.209,5.873,1.309a6.126,6.126,0,0,1,3.493,5.326A5.2,5.2,0,0,1,93.466,338.442ZM90.038,321.25a3.335,3.335,0,1,0,1.772-3.913A3.051,3.051,0,0,0,90.038,321.25Zm4.2,9.173A2.8,2.8,0,1,0,96,334.339,3.05,3.05,0,0,0,94.243,330.423Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_46",
    "data-name": "Elipse 46",
    cx: 0.353,
    cy: 0.353,
    r: 0.353,
    transform: "translate(84.479 326.015)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    "data-name": "Trazado 280",
    d: "M72.052,149.507l5.19,23.062,4.5-5.959,6.51,7.912,4.912-3.959-6.4-7.751,6.773-2.764Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_301",
    "data-name": "Grupo 301"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_47",
    "data-name": "Elipse 47",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(70.139 368.5)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_50",
    "data-name": "L\\xEDnea 50",
    x1: 8.233,
    y1: 8.233,
    transform: "translate(87.21 385.571)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Componente_2_108",
    "data-name": "Componente 2 \\u2013 108",
    transform: "translate(1257.369 338.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_49",
    "data-name": "Grupo 49"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_18",
    "data-name": "L\\xEDnea 18",
    y2: 104.556,
    transform: "translate(54.315)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_19",
    "data-name": "L\\xEDnea 19",
    x2: 108.631,
    transform: "translate(0 52.278)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(15.909 13.806)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_20",
    "data-name": "L\\xEDnea 20",
    x1: 73.807,
    y2: 73.932,
    transform: "translate(1.503 1.506)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_21",
    "data-name": "L\\xEDnea 21",
    x2: 76.814,
    y2: 76.944,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1656",
    "data-name": "Grupo 1656",
    transform: "translate(-86.64 282.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_897",
    "data-name": "Rect\\xE1ngulo 897",
    transform: "translate(1464.64 755.13)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 114,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 309,
    height: 113,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1363",
    "data-name": "Trazado 1363",
    d: "M12.379,8.292H9.6l.956-4.476H9.315L8.337,8.292H5.426L6.4,3.816H5.144L4.209,8.292H1.385l-.217,1.13h2.8l-.826,3.694H.407L.168,14.288H2.906l-.934,4.345H3.188l.978-4.345H7.077l-.956,4.345h1.26l.934-4.345H11.14l.217-1.173h-2.8l.8-3.694h2.759ZM5.187,9.422H8.12l-.8,3.694H4.361ZM17.81,7.879,15.181,3.816H13.052l4.758,7.17-4.932,7.648h2l2.607-4.215L18.723,12.4h.043q.3.5.608.989t.608.989l2.651,4.259h2.108L19.788,10.9l4.737-7.083H22.547l-2.586,4.02q-.3.456-.543.858t-.5.88h-.065q-.239-.435-.489-.826Zm12.254,0L27.436,3.816H25.306l4.758,7.17-4.932,7.648h2l2.607-4.215L30.977,12.4h.043q.3.5.608.989t.608.989l2.651,4.259H37L32.042,10.9l4.737-7.083H34.8l-2.586,4.02q-.3.456-.543.858t-.5.88h-.065q-.239-.435-.489-.826Zm12.254,0L39.69,3.816H37.56l4.758,7.17-4.932,7.648h2l2.607-4.215L43.231,12.4h.043q.3.5.608.989t.608.989l2.651,4.259H49.25L44.3,10.9l4.737-7.083H47.055L44.47,7.836q-.3.456-.543.858t-.5.88h-.065q-.239-.435-.489-.826Zm12.254,0L51.944,3.816H49.814l4.758,7.17-4.932,7.648h2l2.607-4.215L55.485,12.4h.043q.3.5.608.989t.608.989L59.4,18.634H61.5L56.55,10.9l4.737-7.083H59.309l-2.586,4.02q-.3.456-.543.858t-.5.88h-.065q-.239-.435-.489-.826Zm12.254,0L64.2,3.816H62.069l4.758,7.17-4.932,7.648h2L66.5,14.419,67.739,12.4h.043q.3.5.608.989t.608.989l2.651,4.259h2.108L68.8,10.9,73.54,3.816H71.563l-2.586,4.02q-.3.456-.543.858t-.5.88H67.87q-.239-.435-.489-.826Zm12.254,0L76.452,3.816H74.323l4.758,7.17-4.932,7.648h2l2.607-4.215L79.993,12.4h.043q.3.5.608.989t.608.989L83.9,18.634h2.108L81.058,10.9l4.737-7.083H83.817l-2.586,4.02q-.3.456-.543.858t-.5.88h-.065q-.239-.435-.489-.826Z",
    transform: "translate(1483.338 768.922)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_898",
    "data-name": "Rect\\xE1ngulo 898",
    transform: "translate(1464.64 806.13)",
    fill: "#ffc0d4",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62,
    height: 62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_899",
    "data-name": "Rect\\xE1ngulo 899",
    transform: "translate(1526.64 806.13)",
    fill: "#ec4b27",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62,
    height: 62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_900",
    "data-name": "Rect\\xE1ngulo 900",
    transform: "translate(1588.64 806.13)",
    fill: "#256ae4",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62,
    height: 62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_901",
    "data-name": "Rect\\xE1ngulo 901",
    transform: "translate(1649.64 806.13)",
    fill: "#fadc4b",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62,
    height: 62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_902",
    "data-name": "Rect\\xE1ngulo 902",
    transform: "translate(1711.64 806.13)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62,
    height: 62,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1666",
    "data-name": "Grupo 1666",
    transform: "translate(0 257.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_565",
    "data-name": "Grupo 565",
    transform: "translate(-371 -5.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_703",
    "data-name": "Rect\\xE1ngulo 703",
    transform: "translate(1423 671)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 37,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 179,
    height: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Button",
    transform: "translate(1423 679)",
    fontSize: 18,
    fontFamily: "HarmoniaSansW01-Regular"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.713,
    y: 17
  }, "Button"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1655",
    "data-name": "Grupo 1655",
    transform: "translate(-361 -79.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1362",
    "data-name": "Trazado 1362",
    d: "M12.131,11.6h2.854a5.892,5.892,0,0,0-.69-2.037,5.957,5.957,0,0,0-1.363-1.652A6.249,6.249,0,0,0,10.976,6.8a7.3,7.3,0,0,0-2.469-.4,7.258,7.258,0,0,0-2.566.433,6,6,0,0,0-1.988,1.2,5.524,5.524,0,0,0-1.3,1.8,5.223,5.223,0,0,0-.465,2.181,5.4,5.4,0,0,0,1.475,3.945,10.552,10.552,0,0,0,4.49,2.437,8.756,8.756,0,0,1,3.528,1.86,3.97,3.97,0,0,1,1.155,2.983,4.466,4.466,0,0,1-.257,1.475,4.052,4.052,0,0,1-.77,1.331,3.853,3.853,0,0,1-1.3.962,4.22,4.22,0,0,1-1.812.369,4.285,4.285,0,0,1-2.951-.994,5.288,5.288,0,0,1-1.571-2.662H1.259A7.385,7.385,0,0,0,3.937,28.24a7.791,7.791,0,0,0,4.73,1.443,7.207,7.207,0,0,0,2.983-.577A6.464,6.464,0,0,0,13.8,27.583a6.4,6.4,0,0,0,1.3-2.117,6.838,6.838,0,0,0,.433-2.389,8.1,8.1,0,0,0-.321-2.325,5.486,5.486,0,0,0-1.074-1.972,7.42,7.42,0,0,0-2-1.62A14.319,14.319,0,0,0,9.02,15.893a9,9,0,0,1-3.031-1.459,2.928,2.928,0,0,1-1.106-2.421,3.158,3.158,0,0,1,.962-2.373,3.67,3.67,0,0,1,2.662-.93,3.543,3.543,0,0,1,2.453.818A3.694,3.694,0,0,1,12.131,11.6ZM32.464,28.978V13.616H29.93v8.21a6.075,6.075,0,0,1-1.155,4.041,3.924,3.924,0,0,1-3.143,1.347,3.321,3.321,0,0,1-2.71-1.235,5.525,5.525,0,0,1-1.01-3.576V13.616H19.379V22.6a8.806,8.806,0,0,0,.529,3.271A6.035,6.035,0,0,0,21.287,28a5.07,5.07,0,0,0,1.876,1.171,6.28,6.28,0,0,0,2.053.353,5.965,5.965,0,0,0,2.421-.529,5.729,5.729,0,0,0,2.229-1.908h.064v1.892ZM36.89,13.616v22.9h2.534V26.926h.064a7.561,7.561,0,0,0,2.261,1.812,6.982,6.982,0,0,0,3.416.786,7.641,7.641,0,0,0,5.6-2.389A8.084,8.084,0,0,0,52.4,24.52a8.764,8.764,0,0,0,.593-3.239,9.209,9.209,0,0,0-.513-3.047,7.852,7.852,0,0,0-1.507-2.614A7.391,7.391,0,0,0,45.261,13.1a7.66,7.66,0,0,0-2.069.257,7.375,7.375,0,0,0-1.6.641,6.079,6.079,0,0,0-1.2.866,11.922,11.922,0,0,0-.9.93h-.064V13.616Zm13.47,7.665a7,7,0,0,1-.353,2.2,5.8,5.8,0,0,1-1.042,1.908,5.315,5.315,0,0,1-1.748,1.363,5.681,5.681,0,0,1-4.57.1,5.548,5.548,0,0,1-3-3.063,6.259,6.259,0,0,1-.449-2.405,6.773,6.773,0,0,1,.433-2.486A6.03,6.03,0,0,1,40.8,16.983a5.051,5.051,0,0,1,1.748-1.235,5.437,5.437,0,0,1,2.165-.433,5.6,5.6,0,0,1,2.469.513,5.308,5.308,0,0,1,1.764,1.347,5.652,5.652,0,0,1,1.058,1.908A7,7,0,0,1,50.36,21.281ZM62.932,13.1a7.352,7.352,0,0,0-3.143.657,7.5,7.5,0,0,0-2.405,1.748,7.784,7.784,0,0,0-1.539,2.55,8.59,8.59,0,0,0-.545,3.031,9.2,9.2,0,0,0,.593,3.335A8.238,8.238,0,0,0,57.544,27.1a7.42,7.42,0,0,0,2.566,1.78,8.434,8.434,0,0,0,3.335.641,7.5,7.5,0,0,0,4.378-1.331,7.15,7.15,0,0,0,1.443-1.315,8.49,8.49,0,0,0,.978-1.459H67.325A5.394,5.394,0,0,1,65.674,26.8a4.891,4.891,0,0,1-2.293.481,5.054,5.054,0,0,1-2.069-.433,5.985,5.985,0,0,1-1.732-1.155,5.633,5.633,0,0,1-1.2-1.668,4.618,4.618,0,0,1-.449-2h12.54a2.483,2.483,0,0,0,.048-.417q.016-.289.016-.513a9.757,9.757,0,0,0-.4-2.662,7.632,7.632,0,0,0-1.3-2.582,7.243,7.243,0,0,0-2.357-1.956A7.387,7.387,0,0,0,62.932,13.1Zm0,2.213a4.686,4.686,0,0,1,1.924.385,5.109,5.109,0,0,1,1.507,1.01A4.866,4.866,0,0,1,67.39,18.17a5.508,5.508,0,0,1,.481,1.732h-9.91a5.754,5.754,0,0,1,.465-1.7,4.833,4.833,0,0,1,1.01-1.475,4.839,4.839,0,0,1,3.5-1.411Zm18.922.224V13.2a7.474,7.474,0,0,0-1.283-.1,4.123,4.123,0,0,0-1.427.241,5.594,5.594,0,0,0-1.187.593,4.308,4.308,0,0,0-.9.786,4.156,4.156,0,0,0-.561.818h-.064V13.616H73.9V28.978h2.534V20.832a8.926,8.926,0,0,1,.3-2.486,4.857,4.857,0,0,1,.834-1.7,3.185,3.185,0,0,1,1.251-.962,3.957,3.957,0,0,1,1.555-.3,6.19,6.19,0,0,1,.85.048Q81.565,15.476,81.854,15.54ZM99.461,13.1a7.352,7.352,0,0,0-3.143.657,7.5,7.5,0,0,0-2.405,1.748,7.784,7.784,0,0,0-1.539,2.55,8.59,8.59,0,0,0-.545,3.031,9.2,9.2,0,0,0,.593,3.335A8.238,8.238,0,0,0,94.073,27.1a7.42,7.42,0,0,0,2.566,1.78,8.434,8.434,0,0,0,3.335.641,7.5,7.5,0,0,0,4.378-1.331,7.15,7.15,0,0,0,1.443-1.315,8.49,8.49,0,0,0,.978-1.459h-2.918A5.394,5.394,0,0,1,102.2,26.8a4.891,4.891,0,0,1-2.293.481,5.054,5.054,0,0,1-2.069-.433,5.985,5.985,0,0,1-1.732-1.155,5.633,5.633,0,0,1-1.2-1.668,4.618,4.618,0,0,1-.449-2H107a2.481,2.481,0,0,0,.048-.417q.016-.289.016-.513a9.757,9.757,0,0,0-.4-2.662,7.632,7.632,0,0,0-1.3-2.582A7.243,7.243,0,0,0,103,13.889,7.387,7.387,0,0,0,99.461,13.1Zm0,2.213a4.686,4.686,0,0,1,1.924.385,5.108,5.108,0,0,1,1.507,1.01,4.866,4.866,0,0,1,1.026,1.459A5.507,5.507,0,0,1,104.4,19.9H94.49a5.754,5.754,0,0,1,.465-1.7,4.833,4.833,0,0,1,1.01-1.475,4.839,4.839,0,0,1,3.5-1.411Zm15.17,5.773-5.677,7.89h2.886l2.886-4.233,1.155-1.636h.1q.289.417.561.8t.561.8l2.983,4.265h2.983l-5.709-7.954,5.356-7.408h-2.918l-2.662,3.945q-.257.385-.529.754t-.529.754h-.064q-.224-.321-.449-.69t-.577-.914l-2.726-3.849h-2.951ZM133.007,13.1a8.4,8.4,0,0,0-3.351.641,7.681,7.681,0,0,0-2.55,1.748,7.569,7.569,0,0,0-1.62,2.6,9.348,9.348,0,0,0,.048,6.51,7.564,7.564,0,0,0,1.716,2.614,7.933,7.933,0,0,0,2.6,1.7,8.612,8.612,0,0,0,3.287.609,7.9,7.9,0,0,0,2.742-.433,7.305,7.305,0,0,0,2.02-1.106,6.542,6.542,0,0,0,1.411-1.523,7.318,7.318,0,0,0,.85-1.716h-2.822a5,5,0,0,1-1.411,1.748,4.26,4.26,0,0,1-2.758.786,5.54,5.54,0,0,1-2.245-.449,5.369,5.369,0,0,1-1.78-1.251,5.7,5.7,0,0,1-1.171-1.892,6.684,6.684,0,0,1-.417-2.405,6.96,6.96,0,0,1,.449-2.6,5.634,5.634,0,0,1,1.187-1.876,4.663,4.663,0,0,1,1.732-1.122,5.945,5.945,0,0,1,2.085-.369,4.872,4.872,0,0,1,2.646.641,3.8,3.8,0,0,1,1.459,1.6h2.822a5.79,5.79,0,0,0-2-2.886,7.452,7.452,0,0,0-2.069-1.122A8.247,8.247,0,0,0,133.007,13.1Zm10.391.513V28.978h2.534V13.616Zm-.289-6.671V9.928h3.143V6.945Zm5.58,6.671v2.117h2.02v8.018a12.784,12.784,0,0,0,.16,2.069,4.547,4.547,0,0,0,.641,1.732,3.315,3.315,0,0,0,1.347,1.187,5.113,5.113,0,0,0,2.277.433,7.582,7.582,0,0,0,2.373-.321V26.765a6.967,6.967,0,0,1-1.86.257,3.47,3.47,0,0,1-1.058-.144,1.64,1.64,0,0,1-.754-.5,2.25,2.25,0,0,1-.449-.978,7.06,7.06,0,0,1-.144-1.555V15.733h4.105V13.616h-4.105V8.709h-2.534v4.907Zm11.93,0V28.978h2.534V13.616Zm-.289-6.671V9.928h3.143V6.945Zm7.248,6.671V28.978h2.534V20.8a5.918,5.918,0,0,1,1.219-4.057,4.208,4.208,0,0,1,3.3-1.363,3.555,3.555,0,0,1,2.87,1.235,5.4,5.4,0,0,1,1.042,3.576v8.788h2.534V20.03a8.354,8.354,0,0,0-.561-3.271,6.269,6.269,0,0,0-1.427-2.133,5.138,5.138,0,0,0-1.94-1.171,6.805,6.805,0,0,0-2.133-.353,6.492,6.492,0,0,0-2.518.529,5.809,5.809,0,0,0-2.325,1.908h-.064V13.616ZM200.357,28.5V13.616h-2.534v2.213h-.064a8.443,8.443,0,0,0-.866-.93,6.379,6.379,0,0,0-1.219-.882,7.369,7.369,0,0,0-1.588-.657,7.053,7.053,0,0,0-1.972-.257,7.881,7.881,0,0,0-3.127.609,7.566,7.566,0,0,0-2.486,1.7,7.765,7.765,0,0,0-1.652,2.6,8.853,8.853,0,0,0-.593,3.271,8.6,8.6,0,0,0,.641,3.4,8.132,8.132,0,0,0,1.732,2.6,7.506,7.506,0,0,0,2.518,1.668,7.922,7.922,0,0,0,3,.577,6.6,6.6,0,0,0,3.367-.818,8.044,8.044,0,0,0,2.245-1.844h.064v1.956a6.944,6.944,0,0,1-1.347,4.586,4.861,4.861,0,0,1-3.945,1.6,6.513,6.513,0,0,1-2.053-.289,4.814,4.814,0,0,1-1.475-.77,3.963,3.963,0,0,1-.994-1.155,5.661,5.661,0,0,1-.577-1.443h-2.566a6.984,6.984,0,0,0,2.421,4.249,7.772,7.772,0,0,0,5.147,1.62q4.041,0,5.981-2.261A9.641,9.641,0,0,0,200.357,28.5Zm-13.5-7.216a6.9,6.9,0,0,1,.353-2.165,5.682,5.682,0,0,1,1.074-1.924,5.382,5.382,0,0,1,1.78-1.363,5.6,5.6,0,0,1,2.469-.513,5.437,5.437,0,0,1,2.165.433,5.051,5.051,0,0,1,1.748,1.235,6.03,6.03,0,0,1,1.171,1.908,6.774,6.774,0,0,1,.433,2.486,6.139,6.139,0,0,1-.449,2.389,5.85,5.85,0,0,1-1.219,1.86,5.5,5.5,0,0,1-1.78,1.219,5.681,5.681,0,0,1-4.57-.1,5.494,5.494,0,0,1-1.764-1.363,5.652,5.652,0,0,1-1.058-1.908A7,7,0,0,1,186.855,21.281ZM.425,52.1v2.117h2.02v8.018a12.784,12.784,0,0,0,.16,2.069,4.547,4.547,0,0,0,.641,1.732,3.315,3.315,0,0,0,1.347,1.187,5.114,5.114,0,0,0,2.277.433,7.582,7.582,0,0,0,2.373-.321V65.251a6.968,6.968,0,0,1-1.86.257,3.47,3.47,0,0,1-1.058-.144,1.64,1.64,0,0,1-.754-.5,2.25,2.25,0,0,1-.449-.978,7.061,7.061,0,0,1-.144-1.555V54.218H9.084V52.1H4.979V47.195H2.445V52.1Zm11.93,0V67.464h2.534V52.1Zm-.289-6.671v2.983H15.21V45.431Zm5.58,6.671v2.117h2.02v8.018a12.784,12.784,0,0,0,.16,2.069,4.547,4.547,0,0,0,.641,1.732,3.315,3.315,0,0,0,1.347,1.187,5.114,5.114,0,0,0,2.277.433,7.582,7.582,0,0,0,2.373-.321V65.251a6.968,6.968,0,0,1-1.86.257,3.47,3.47,0,0,1-1.058-.144,1.64,1.64,0,0,1-.754-.5,2.25,2.25,0,0,1-.449-.978,7.061,7.061,0,0,1-.144-1.555V54.218h4.105V52.1H22.2V47.195H19.668V52.1Zm11.93-7.729V67.464h2.534V44.372Zm13.534,7.216a7.352,7.352,0,0,0-3.143.657,7.5,7.5,0,0,0-2.405,1.748,7.784,7.784,0,0,0-1.539,2.55,8.59,8.59,0,0,0-.545,3.031,9.2,9.2,0,0,0,.593,3.335,8.238,8.238,0,0,0,1.652,2.678,7.42,7.42,0,0,0,2.566,1.78,8.434,8.434,0,0,0,3.335.641A7.5,7.5,0,0,0,48,66.678a7.15,7.15,0,0,0,1.443-1.315,8.49,8.49,0,0,0,.978-1.459H47.506a5.394,5.394,0,0,1-1.652,1.379,4.891,4.891,0,0,1-2.293.481,5.054,5.054,0,0,1-2.069-.433,5.985,5.985,0,0,1-1.732-1.155,5.633,5.633,0,0,1-1.2-1.668,4.618,4.618,0,0,1-.449-2h12.54a2.482,2.482,0,0,0,.048-.417q.016-.289.016-.513a9.757,9.757,0,0,0-.4-2.662,7.632,7.632,0,0,0-1.3-2.582,7.243,7.243,0,0,0-2.357-1.956A7.387,7.387,0,0,0,43.112,51.588Zm0,2.213a4.686,4.686,0,0,1,1.924.385,5.108,5.108,0,0,1,1.507,1.01,4.866,4.866,0,0,1,1.026,1.459,5.507,5.507,0,0,1,.481,1.732h-9.91a5.754,5.754,0,0,1,.465-1.7,4.833,4.833,0,0,1,1.01-1.475,4.839,4.839,0,0,1,3.5-1.411Z",
    transform: "translate(1414.422 657.448)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_896",
    "data-name": "Rect\\xE1ngulo 896",
    transform: "translate(1414 662.274)",
    fill: "none",
    stroke: "#256ae4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 201,
    height: 65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_265",
    "data-name": "Elipse 265",
    transform: "translate(1510 658.274)",
    fill: "#fff",
    stroke: "#256ae4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_266",
    "data-name": "Elipse 266",
    transform: "translate(1510 722.274)",
    fill: "#fff",
    stroke: "#256ae4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_267",
    "data-name": "Elipse 267",
    transform: "translate(1611 690.274)",
    fill: "#fff",
    stroke: "#256ae4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_268",
    "data-name": "Elipse 268",
    transform: "translate(1410 690.274)",
    fill: "#fff",
    stroke: "#256ae4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1662",
    "data-name": "Grupo 1662",
    transform: "translate(-284 48.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_687",
    "data-name": "Rect\\xE1ngulo 687",
    transform: "translate(1311 504)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 355,
    height: 179,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 354,
    height: 178,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1657",
    "data-name": "Grupo 1657",
    transform: "translate(933.696 45.404)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_647-2",
    "data-name": "Rect\\xE1ngulo 647",
    width: 10.948,
    height: 10.948,
    transform: "translate(373.45 454.838)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_648-2",
    "data-name": "Rect\\xE1ngulo 648",
    width: 10.218,
    height: 10.218,
    transform: "translate(372.72 454.108)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1658",
    "data-name": "Grupo 1658",
    transform: "translate(933.696 223.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_647-3",
    "data-name": "Rect\\xE1ngulo 647",
    width: 10.948,
    height: 10.948,
    transform: "translate(373.45 454.838)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_648-3",
    "data-name": "Rect\\xE1ngulo 648",
    width: 10.218,
    height: 10.218,
    transform: "translate(372.72 454.108)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1659",
    "data-name": "Grupo 1659",
    transform: "translate(1286.28 223.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_647-4",
    "data-name": "Rect\\xE1ngulo 647",
    width: 10.948,
    height: 10.948,
    transform: "translate(373.45 454.838)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_648-4",
    "data-name": "Rect\\xE1ngulo 648",
    width: 10.218,
    height: 10.218,
    transform: "translate(372.72 454.108)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1660",
    "data-name": "Grupo 1660",
    transform: "translate(1286.28 44.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_647-5",
    "data-name": "Rect\\xE1ngulo 647",
    width: 10.948,
    height: 10.948,
    transform: "translate(373.45 454.838)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_648-5",
    "data-name": "Rect\\xE1ngulo 648",
    width: 10.218,
    height: 10.218,
    transform: "translate(372.72 454.108)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349",
    transform: "translate(-21 -3335.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_347",
    "data-name": "Grupo 347",
    transform: "translate(463 3671.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_1",
    "data-name": "Uni\\xF3n 1",
    d: "M0,41.808A41.808,41.808,0,0,1,41.808,0H196.536a41.807,41.807,0,1,1,0,83.615H42.118L0,109.838Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1364",
    "data-name": "Trazado 1364",
    d: "M109.122,19.376l3.807,15.442H116.1l6.084-24.266h-3.024l-3.736,15.62q-.178.747-.445,2.046t-.48,2.722h-.142q-.178-1.1-.374-2.188t-.587-2.615l-3.807-15.584h-2.918L102.86,25.887q-.356,1.423-.551,2.669T101.9,30.94h-.142q-.107-.569-.2-1.05t-.213-1q-.125-.516-.285-1.156t-.374-1.53L96.7,10.552H93.68L100.3,34.818h2.953l3.772-15.549q.213-.854.356-1.512t.249-1.228q.107-.569.2-1.121t.2-1.192h.142q.071.64.16,1.228t.2,1.174q.107.587.249,1.263T109.122,19.376ZM125.2,9.2V34.818h2.811V25.709a6.5,6.5,0,0,1,1.352-4.483,4.7,4.7,0,0,1,3.665-1.494,3.944,3.944,0,0,1,3.184,1.37,5.935,5.935,0,0,1,1.156,3.932v9.785h2.811V24.891a9.4,9.4,0,0,0-.623-3.647,6.73,6.73,0,0,0-1.583-2.366,5.81,5.81,0,0,0-2.153-1.281,7.55,7.55,0,0,0-2.366-.391,7.074,7.074,0,0,0-2.775.587,6.733,6.733,0,0,0-2.6,2.117h-.071V9.2Zm22.95,33.98,9.393-25.4H154.7L151.143,27.7q-.32.925-.6,1.8t-.569,1.8H149.9q-.071-.356-.213-.836t-.3-1q-.16-.516-.338-.978t-.285-.783l-3.594-9.927h-2.882l6.262,17.043-3.1,8.361Zm20.6-19.818q.6-.6,1.263-1.316a11.936,11.936,0,0,0,1.228-1.583,8.371,8.371,0,0,0,.925-1.939,7.39,7.39,0,0,0,.356-2.348,6.634,6.634,0,0,0-.445-2.4,5.94,5.94,0,0,0-1.316-2.046A6.329,6.329,0,0,0,168.56,10.3a8.349,8.349,0,0,0-3.113-.534,7.876,7.876,0,0,0-2.811.5,6.956,6.956,0,0,0-2.295,1.405,6.6,6.6,0,0,0-1.548,2.188,7.267,7.267,0,0,0-.6,2.811h3.1a4.8,4.8,0,0,1,.32-1.8,3.968,3.968,0,0,1,.872-1.352,3.657,3.657,0,0,1,1.3-.836,4.36,4.36,0,0,1,1.566-.285,4.53,4.53,0,0,1,1.761.32,3.85,3.85,0,0,1,1.3.872,3.6,3.6,0,0,1,.8,1.281,4.575,4.575,0,0,1,.267,1.583,4.255,4.255,0,0,1-.249,1.512,6.007,6.007,0,0,1-.694,1.3,11.2,11.2,0,0,1-1.067,1.3q-.623.658-1.37,1.512a8.37,8.37,0,0,0-1.032,1.388,6.617,6.617,0,0,0-.6,1.37,7.256,7.256,0,0,0-.285,1.494q-.071.8-.071,1.761h2.6a8.13,8.13,0,0,1,.107-1.37,5.12,5.12,0,0,1,.356-1.192,5.324,5.324,0,0,1,.64-1.085A10.725,10.725,0,0,1,168.756,23.361Zm-4.946,8.326v3.131h3.131V31.687Z",
    transform: "translate(455.148 3691.974)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1663",
    "data-name": "Grupo 1663",
    transform: "translate(-295.392 -3297.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_347-2",
    "data-name": "Grupo 347",
    transform: "translate(544.708 3671.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_1-2",
    "data-name": "Uni\\xF3n 1",
    d: "M42.446,111.515A42.445,42.445,0,0,1,0,69.07H0V0L42.762,26.624h73.821a42.445,42.445,0,1,1,0,84.891Z",
    transform: "translate(159.028 111.514) rotate(180)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1364-2",
    "data-name": "Trazado 1364",
    d: "M158.319,19.943h0Zm14.244,7.1q.769-.769,1.605-1.673a15.166,15.166,0,0,0,1.56-2.012,10.638,10.638,0,0,0,1.176-2.464,9.391,9.391,0,0,0,.452-2.984,8.431,8.431,0,0,0-.565-3.052,7.549,7.549,0,0,0-1.673-2.6,8.043,8.043,0,0,0-2.8-1.809,10.61,10.61,0,0,0-3.957-.678,10.01,10.01,0,0,0-3.572.633,8.84,8.84,0,0,0-2.917,1.786,8.389,8.389,0,0,0-1.967,2.781,9.235,9.235,0,0,0-.769,3.572h3.934a6.1,6.1,0,0,1,.407-2.284,5.042,5.042,0,0,1,1.108-1.718,4.647,4.647,0,0,1,1.651-1.063,5.541,5.541,0,0,1,1.99-.362,5.757,5.757,0,0,1,2.238.407,4.893,4.893,0,0,1,1.651,1.108,4.573,4.573,0,0,1,1.017,1.628,5.814,5.814,0,0,1,.339,2.012,5.408,5.408,0,0,1-.317,1.922,7.636,7.636,0,0,1-.882,1.65,14.236,14.236,0,0,1-1.357,1.65q-.791.837-1.741,1.922a10.639,10.639,0,0,0-1.311,1.764,8.411,8.411,0,0,0-.769,1.741,9.224,9.224,0,0,0-.362,1.9q-.09,1.017-.09,2.238h3.3a10.33,10.33,0,0,1,.136-1.741,6.509,6.509,0,0,1,.452-1.515,6.765,6.765,0,0,1,.814-1.379A13.623,13.623,0,0,1,172.563,27.043Zm-6.285,10.581V41.6h3.979V37.624Z",
    transform: "translate(454.879 3689.076)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkHero);
export default __webpack_public_path__ + "static/media/work_hero.2d8ec166dd2f89626c2307527cd6d7d1.svg";
export { ForwardRef as ReactComponent };